import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut, updatePassword , createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc,addDocs, setDoc, updateDoc, collection, addDoc,onSnapshot, getDocs,Timestamp , deleteDoc, query, where, orderBy } from 'firebase/firestore';
import { db, secondaryAuth } from '../components/firebase-config.js';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import AffiliationRequestsManager from './AffiliationRequestsManager.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { 
  faHome, faUserMd, faUser, faCalendarAlt, faArchive, 
  faLink, faKey, faBars,faPlus,faArrowLeft,faArrowRight,faUserPlus,faCalendarPlus,faSignOutAlt, faPlusCircle, faFilter,
  faEdit, faTrash, faClock, faCheck, faTimes, faExclamationTriangle,
  faFile, faSearch, faChevronLeft, faChevronRight, faPhone, faEnvelope,
  faCalendarDay, faCalendarWeek, faCalendarCheck, faExchangeAlt, faEye, faBolt, faInfoCircle, faSpinner, faSync
} from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import './StructureDashboard.css';

import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import { Modal, Button, Form } from 'react-bootstrap';




const Rapports = () => {
  const [structureData, setStructureData] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [form, setForm] = useState({});
  const [activeTab, setActiveTab] = useState('rendezvous'); //info,  rendezvous , patients, doctors, 
  const [medecins, setMedecins] = useState([]);
  const [patients, setPatients] = useState([]);
  const [rendezvous, setRendezvous] = useState([]);
  const [showMedecinForm, setShowMedecinForm] = useState(false);
  const [showPatientForm, setShowPatientForm] = useState(false);
  const [showRendezvousForm, setShowRendezvousForm] = useState(false);
  const [currentMedecin, setCurrentMedecin] = useState(null);
  const [currentPatient, setCurrentPatient] = useState(null);
  const [currentRendezvous, setCurrentRendezvous] = useState(null);
  const [filtreDate, setFiltreDate] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  });
  
  
  const [filtreMedecin, setFiltreMedecin] = useState('');
  const [archives, setArchives] = useState([]);
  const [showArchiveForm, setShowArchiveForm] = useState(false);
  const [currentArchive, setCurrentArchive] = useState(null);
  const [archiveFiles, setArchiveFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [filtreArchivePatient, setFiltreArchivePatient] = useState('');
  const [pendingRequests, setPendingRequests] = useState([]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 999);
  
  const MAYTAPI_PRODUCT_ID = '5e994f76-4f49-4057-aca4-6bef3b1de795'; // À remplacer par votre Product ID Maytapi
const MAYTAPI_API_TOKEN = 'a0b5ba45-b4da-429e-ba5b-127851d9b92e'; // À remplacer par votre token API Maytapi
const MAYTAPI_PHONE_ID = '85860'; // À remplacer par votre Phone ID Maytapi

// Fonction pour envoyer un message WhatsApp via Maytapi
const sendWhatsAppMessage = async (phoneNumber, message) => {
  try {
    const response = await axios({
      method: 'post',
      url: `https://api.maytapi.com/api/${MAYTAPI_PRODUCT_ID}/${MAYTAPI_PHONE_ID}/sendMessage`,
      headers: {
        'Content-Type': 'application/json',
        'x-maytapi-key': MAYTAPI_API_TOKEN
      },
      data: {
        to_number: phoneNumber,
        message: message,
        type: 'text'
      }
    });
    
    console.log('Message WhatsApp envoyé avec succès:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'envoi du message WhatsApp:', error);
    throw error;
  }
};



// Fonction pour générer un mot de passe aléatoire
const generateRandomPassword = (length = 10) => {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
  let password = '';
  
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    password += charset[randomIndex];
  }
  
  return password;
};



  // État du formulaire d'archive
  const [archiveForm, setArchiveForm] = useState({
    patientId: '',
    titre: '',
    description: '',
    notes: '',
    date: new Date().toISOString().split('T')[0],
    tags: [],
    files: []
  });
  
  // Constantes
  const tagsList = ["Consultation", "Examen", "Ordonnance", "Analyse", "Radiologie", "Hospitalisation", "Chirurgie", "Suivi", "Autre"];
  const storage = getStorage();
  
  // État du formulaire médecin
  const [medecinForm, setMedecinForm] = useState({
    nom: '',
    prenom: '',
    specialite: '',
    telephone: '',
    email: '',
    password: '',
    disponibilites: {
      lundi: { actif: false, debut: '08:00', fin: '18:00' },
      mardi: { actif: false, debut: '08:00', fin: '18:00' },
      mercredi: { actif: false, debut: '08:00', fin: '18:00' },
      jeudi: { actif: false, debut: '08:00', fin: '18:00' },
      vendredi: { actif: false, debut: '08:00', fin: '18:00' },
      samedi: { actif: false, debut: '08:00', fin: '18:00' },
      dimanche: { actif: false, debut: '08:00', fin: '18:00' }
    },
    assurances: []
  });
  
  // État du formulaire patient
  const [patientForm, setPatientForm] = useState({
    nom: '',
    prenom: '',
    dateNaissance: '',
    email: '',
    password: '',
    telephone: '',
    assurances: [],
    diagnostics: '' // Ajout du champ diagnostics
  });
  
  
  // État du formulaire rendez-vous
  const [rdvForm, setRdvForm] = useState({
    medecinId: '',
    patientId: '',
    date: new Date().toISOString().split('T')[0],
    heure: '08:00',
    duree: 5,
    motif: '',
    statut: 'confirmé'
  });
  
  // Constantes
  const specialites = ["Généraliste", "Cardiologue", "Dermatologue", "Pédiatre", "Gynécologue", "Ophtalmologue", "Autre"];
  const assurancesList = ["CNAM", "CNSS", "CNRPS", "Assurance privée", "Autre"];
  const joursSemaine = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"];
  const statutsRdv = [ "confirmé", "terminé", "annulé"];
  const dureesRdv = [15, 30, 45, 60, 90, 120];
  
  // États pour la vue calendrier
  const [calendarView, setCalendarView] = useState('month');
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [showDateModal, setShowDateModal] = useState(false);
  const [showMedecinRdvModal, setShowMedecinRdvModal] = useState(false);
  const [selectedMedecinId, setSelectedMedecinId] = useState(null);
  const [showRdvDetailsModal, setShowRdvDetailsModal] = useState(false);
  const [selectedRdv, setSelectedRdv] = useState(null);
  const [draggedRdv, setDraggedRdv] = useState(null);
    // Variables d'état pour l'interface mobile
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [showMobileActionMenu, setShowMobileActionMenu] = useState(false);
    const [mobileDetailView, setMobileDetailView] = useState(null);
    const [mobileSearchActive, setMobileSearchActive] = useState(false);
    const [mobileSearchQuery, setMobileSearchQuery] = useState('');

    const [quickRequests, setQuickRequests] = useState([]);
    const [showQuickRequestsModal, setShowQuickRequestsModal] = useState(false);
    const [selectedQuickRequest, setSelectedQuickRequest] = useState(null);
    const [assignMedecinModal, setAssignMedecinModal] = useState(false);
    const [selectedMedecinForQuick, setSelectedMedecinForQuick] = useState('');
    const [quickRequestsCount, setQuickRequestsCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const [demandesRapides, setDemandesRapides] = useState([]);
    const [activeTabRdv, setActiveTabRdv] = useState('attente');
    const [demandesAcceptees, setDemandesAcceptees] = useState([]);
    const [loadingAcceptees, setLoadingAcceptees] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [pendingDoctorRequests, setPendingDoctorRequests] = useState([]);
    const [affiliationRequests, setAffiliationRequests] = useState([]);

  const navigate = useNavigate();
  const auth = getAuth();

  // Gestion de la taille de l'écran
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 999);
      if (window.innerWidth < 999) {
        setSidebarCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Remplacer les fonctions fetch par des écouteurs temps réel
  const setupRealtimeListeners = (structureId) => {
    // Écouteur pour les médecins
    const unsubscribeMedecins = onSnapshot(
      query(collection(db, 'medecins'), where("structureId", "==", structureId)),
      (snapshot) => {
        const medecinsData = [];
        snapshot.forEach((doc) => {
          medecinsData.push({ id: doc.id, ...doc.data() });
        });
        setMedecins(medecinsData);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des médecins:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );

    // Écouteur pour les patients
    const unsubscribePatients = onSnapshot(
      query(collection(db, 'patients'), where("structureId", "==", structureId)),
      (snapshot) => {
        const patientsData = [];
        snapshot.forEach((doc) => {
          patientsData.push({ id: doc.id, ...doc.data() });
        });
        setPatients(patientsData);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des patients:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );

    // Écouteur pour les rendez-vous
    const unsubscribeRendezvous = onSnapshot(
      query(collection(db, 'rendezvous'), where("structureId", "==", structureId)),
      (snapshot) => {
        const rdvData = [];
        snapshot.forEach((doc) => {
          const rdv = doc.data();
          if (rdv.date) {
            const dateObj = new Date(rdv.date);
            if (!isNaN(dateObj.getTime())) {
              rdv.date = formatDateString(dateObj);
            }
          }
          rdvData.push({ id: doc.id, ...rdv });
        });
        setRendezvous(rdvData);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des rendez-vous:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );

    // Écouteur pour les demandes rapides
    const unsubscribeQuickRequests = onSnapshot(
      query(
        collection(db, 'quickAppointments'),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      ),
      (snapshot) => {
        const requests = [];
        snapshot.forEach((doc) => {
          requests.push({ id: doc.id, ...doc.data() });
        });
        setQuickRequests(requests);
        setQuickRequestsCount(requests.length);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des demandes rapides:", error);
      }
    );

    // Écouteur pour les demandes d'affiliation
    const unsubscribeAffiliationRequests = onSnapshot(
      query(
        collection(db, 'affiliationRequests'),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      ),
      (snapshot) => {
        const requests = [];
        snapshot.forEach((doc) => {
          requests.push({ id: doc.id, ...doc.data() });
        });
        setPendingDoctorRequests(requests);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des demandes d'affiliation:", error);
      }
    );

    // Écouteur pour les archives
    const unsubscribeArchives = onSnapshot(
      query(collection(db, 'archives'), where("structureId", "==", structureId)),
      (snapshot) => {
        const archivesData = [];
        snapshot.forEach((doc) => {
          archivesData.push({ id: doc.id, ...doc.data() });
        });
        setArchives(archivesData);
      },
      (error) => {
        console.error("Erreur lors de l'écoute des archives:", error);
        setMessage(`Erreur: ${error.message}`);
      }
    );

    // Retourner une fonction de nettoyage pour tous les écouteurs
    return () => {
      unsubscribeMedecins();
      unsubscribePatients();
      unsubscribeRendezvous();
      unsubscribeQuickRequests();
      unsubscribeAffiliationRequests();
      unsubscribeArchives(); // Ajouter cette ligne
    };
  };

  // Modifier le useEffect principal pour utiliser les écouteurs temps réel
  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const docRef = doc(db, 'structures', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setStructureData(docSnap.data());
          setForm(docSnap.data());
          
          // Mettre en place les écouteurs temps réel
          const unsubscribeListeners = setupRealtimeListeners(user.uid);
          
          // Nettoyer les écouteurs lors du démontage
          return () => {
            unsubscribeListeners();
          };
        } else {
          navigate('/auth');
        }
      } else {
        navigate('/auth');
      }
    });

    // Nettoyer l'écouteur d'authentification lors du démontage
    return () => {
      unsubscribeAuth();
    };
  }, [auth, navigate]);

  // Récupérer les demandes d'affiliation en attente
  const fetchPendingRequests = async (structureId) => {
    try {
      // Récupérer les demandes d'affiliation des médecins
      const medecinRequestsQuery = query(
        collection(db, 'affiliationRequests'),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      );
      const medecinSnapshot = await getDocs(medecinRequestsQuery);
      const medecinRequests = [];
      medecinSnapshot.forEach((doc) => {
        medecinRequests.push({ id: doc.id, ...doc.data() });
      });
      setPendingDoctorRequests(medecinRequests);

      // Récupérer les demandes d'affiliation des patients
      const patientRequestsQuery = query(
        collection(db, 'affiliations'),
        where("structureId", "==", structureId),
        where("statut", "==", "en attente")
      );
      const patientSnapshot = await getDocs(patientRequestsQuery);
      const patientRequests = [];
      patientSnapshot.forEach((doc) => {
        patientRequests.push({ id: doc.id, ...doc.data() });
      });
      setAffiliationRequests(patientRequests);
    } catch (error) {
      console.error("Erreur lors de la récupération des demandes d'affiliation:", error);
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const fetchArchives = async (structureId) => {
    try {
      const q = query(collection(db, 'archives'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      const archivesData = [];
      querySnapshot.forEach((doc) => {
        archivesData.push({ id: doc.id, ...doc.data() });
      });
      setArchives(archivesData);
    } catch (error) {
      setMessage(`Erreur lors du chargement des archives: ${error.message}`);
    }
  };

  const getFirstDayOfMonth = (year, month) => {
    return new Date(year, month, 1).getDay();
  };

  const getMonthData = useCallback(() => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    
    const daysInMonth = getDaysInMonth(year, month);
    const firstDayOfMonth = getFirstDayOfMonth(year, month);
    
    const days = [];
    
    // Ajouter les jours du mois précédent pour compléter la première semaine
    const prevMonthDays = getDaysInMonth(year, month - 1);
    for (let i = firstDayOfMonth - 1; i >= 0; i--) {
      const date = new Date(year, month - 1, prevMonthDays - i);
      const dateString = formatDateString(date);
      days.push({
        date: date,
        isCurrentMonth: false,
        hasEvents: false,
        events: [],
        dateString: dateString
      });
    }
    
    // Ajouter les jours du mois courant
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(year, month, i);
      const dateString = formatDateString(date);
      
      // Vérifier les rendez-vous pour cette date
      const dayEvents = rendezvous.filter(rdv => {
        // S'assurer que les dates sont comparées dans le même format
        return rdv.date === dateString;
      });
      
      // Obtenir les médecins uniques qui ont des rendez-vous ce jour
      const uniqueMedecins = [...new Set(dayEvents.map(rdv => rdv.medecinId))];
      
      days.push({
        date: date,
        isCurrentMonth: true,
        hasEvents: dayEvents.length > 0,
        events: dayEvents,
        medecinCount: uniqueMedecins.length,
        dateString: dateString
      });
    }
    
    // Ajouter les jours du mois suivant pour compléter la dernière semaine
    const totalDaysToShow = 42; // 6 semaines
    const remainingDays = totalDaysToShow - days.length;
    for (let i = 1; i <= remainingDays; i++) {
      const date = new Date(year, month + 1, i);
      const dateString = formatDateString(date);
      days.push({
        date: date,
        isCurrentMonth: false,
        hasEvents: false,
        events: [],
        dateString: dateString
      });
    }
    
    return days;
  }, [currentMonth, rendezvous]);
  

 const formatDateString = (date) => {
  if (!date) return '';
  
  // S'assurer que date est un objet Date
  const dateObj = date instanceof Date ? date : new Date(date);
  
  // Vérifier si la date est valide
  if (isNaN(dateObj.getTime())) {
    console.error('Date invalide:', date);
    return '';
  }
  
  // Format YYYY-MM-DD
  return `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
};

// Fonction pour afficher la date en format lisible (DD/MM/YYYY)
const formatDate = (date) => {
  if (!date) return '';
  
  // S'assurer que date est un objet Date
  const dateObj = date instanceof Date ? date : new Date(date);
  
  // Vérifier si la date est valide
  if (isNaN(dateObj.getTime())) {
    console.error('Date invalide:', date);
    return '';
  }
  
  // Format DD/MM/YYYY
  return `${String(dateObj.getDate()).padStart(2, '0')}/${String(dateObj.getMonth() + 1).padStart(2, '0')}/${dateObj.getFullYear()}`;
};

  // Récupération des données
  const fetchMedecins = async (structureId) => {
    try {
      const q = query(collection(db, 'medecins'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      const medecinsData = [];
      querySnapshot.forEach((doc) => {
        medecinsData.push({ id: doc.id, ...doc.data() });
      });
      setMedecins(medecinsData);
    } catch (error) {
      setMessage(`Erreur lors du chargement des médecins: ${error.message}`);
    }
  };

  const fetchPatients = async (structureId) => {
    try {
      const q = query(collection(db, 'patients'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      const patientsData = [];
      querySnapshot.forEach((doc) => {
        patientsData.push({ id: doc.id, ...doc.data() });
      });
      setPatients(patientsData);
    } catch (error) {
      setMessage(`Erreur lors du chargement des patients: ${error.message}`);
    }
  };

  const fetchRendezvous = async (structureId) => {
    try {
      const q = query(collection(db, 'rendezvous'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      const rdvData = [];
      
      for (const doc of querySnapshot.docs) {
        const rdv = doc.data();
        const formattedRdv = {
          id: doc.id,
          ...rdv,
          // Formater la date si elle existe
          date: rdv.date ? formatDateString(new Date(rdv.date)) : '',
          // S'assurer que les noms sont correctement formatés
          medecinNom: rdv.medecinNom || 'Non assigné',
          patientNom: rdv.patientNom || 'Patient inconnu',
          // Ajouter des champs par défaut si manquants
          duree: rdv.duree || '30',
          motif: rdv.motif || 'Consultation',
          statut: rdv.statut || 'en attente',
          // Formater les timestamps
          createdAt: rdv.createdAt ? new Date(rdv.createdAt.toDate()).toLocaleString() : '',
          updatedAt: rdv.updatedAt ? new Date(rdv.updatedAt.toDate()).toLocaleString() : ''
        };
        
        // Si le rendez-vous provient d'une demande rapide, s'assurer que toutes les informations sont présentes
        if (rdv.source === 'quick') {
          formattedRdv.patientEmail = rdv.patientEmail || rdv.email || '';
          formattedRdv.patientTelephone = rdv.patientTelephone || rdv.telephone || '';
          formattedRdv.verificationCode = rdv.verificationCode || '';
        }
        
        rdvData.push(formattedRdv);
      }
      
      setRendezvous(rdvData);
    } catch (error) {
      setMessage(`Erreur lors de la récupération des rendez-vous: ${error.message}`);
    }
  };
  

  // Fonctions générales
  const handleLogout = async () => {
    await signOut(auth);
    navigate('/auth');
  };

  const handleUpdate = async () => {
    try {
      const user = auth.currentUser;
      await updateDoc(doc(db, 'structures', user.uid), form);
      setMessage('Informations mises à jour avec succès.');
      
      // Afficher le message puis le faire disparaître après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handlePasswordChange = async () => {
    try {
      const user = auth.currentUser;
      await updatePassword(user, newPassword);
      setMessage('Mot de passe mis à jour avec succès.');
      setNewPassword('');
      
      // Afficher le message puis le faire disparaître après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Gestion des formulaires d'archive
  const handleArchiveChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name === "tags") {
      const updatedArray = [...archiveForm.tags];
      if (checked) {
        updatedArray.push(value);
      } else {
        const index = updatedArray.indexOf(value);
        if (index > -1) {
          updatedArray.splice(index, 1);
        }
      }
      setArchiveForm({ ...archiveForm, [name]: updatedArray });
    } else {
      setArchiveForm({ ...archiveForm, [name]: value });
    }
  };
  
  const resetArchiveForm = () => {
    setArchiveForm({
      patientId: '',
      titre: '',
      description: '',
      notes: '',
      date: new Date().toISOString().split('T')[0],
      tags: [],
      files: []
    });
    setSelectedFiles([]);
    setCurrentArchive(null);
  };
  
  const handleFileChange = (e) => {
    if (e.target.files) {
      setSelectedFiles(Array.from(e.target.files));
    }
  };
  
  const handleAddArchive = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      const fileUrls = [];
      
      // Uploader les fichiers sélectionnés
      if (selectedFiles.length > 0) {
        for (const file of selectedFiles) {
          const storageRef = ref(storage, `archives/${user.uid}/${Date.now()}_${file.name}`);
          await uploadBytes(storageRef, file);
          const downloadURL = await getDownloadURL(storageRef);
          fileUrls.push({ name: file.name, url: downloadURL, path: storageRef.fullPath });
        }
      }
      
      // Récupérer les informations du patient
      const patient = patients.find(p => p.id === archiveForm.patientId);
      
      const archiveData = {
        ...archiveForm,
        patientNom: patient ? `${patient.prenom} ${patient.nom}` : '',
        files: currentArchive ? [...archiveForm.files, ...fileUrls] : fileUrls,
        structureId: user.uid,
        createdAt: new Date()
      };
      
      if (currentArchive) {
        // Mise à jour d'une archive existante
        await updateDoc(doc(db, 'archives', currentArchive.id), {
          ...archiveData,
          updatedAt: new Date()
        });
      } else {
        // Création d'une nouvelle archive
        await addDoc(collection(db, 'archives'), archiveData);
      }
      
      resetArchiveForm();
      setShowArchiveForm(false);
      setMessage('Archive ' + (currentArchive ? 'mise à jour' : 'ajoutée') + ' avec succès.');
      
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };
  
  const handleEditArchive = (archive) => {
    setCurrentArchive(archive);
    setArchiveForm({
      patientId: archive.patientId || '',
      titre: archive.titre || '',
      description: archive.description || '',
      notes: archive.notes || '',
      date: archive.date || new Date().toISOString().split('T')[0],
      tags: archive.tags || [],
      files: archive.files || []
    });
    setShowArchiveForm(true);
  };
  
  const handleDeleteArchive = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette archive ?')) {
      try {
        // Récupérer l'archive pour obtenir les chemins des fichiers
        const archiveDoc = await getDoc(doc(db, 'archives', id));
        const archiveData = archiveDoc.data();
        
        // Supprimer les fichiers du stockage
        if (archiveData.files && archiveData.files.length > 0) {
          for (const file of archiveData.files) {
            if (file.path) {
              const fileRef = ref(storage, file.path);
              await deleteObject(fileRef);
            }
          }
        }
        
        // Supprimer le document de l'archive
        await deleteDoc(doc(db, 'archives', id));
        setMessage('Archive supprimée avec succès.');
        
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur: ${error.message}`);
      }
    }
  };
  
  const handleDeleteFile = async (archiveId, filePath, fileIndex) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce fichier ?')) {
      try {
        // Supprimer le fichier du stockage
        const fileRef = ref(storage, filePath);
        await deleteObject(fileRef);
        
        // Mettre à jour le document de l'archive
        const archiveDoc = await getDoc(doc(db, 'archives', archiveId));
        const archiveData = archiveDoc.data();
        
        const updatedFiles = [...archiveData.files];
        updatedFiles.splice(fileIndex, 1);
        
        await updateDoc(doc(db, 'archives', archiveId), {
          files: updatedFiles,
          updatedAt: new Date()
        });
        
        setMessage('Fichier supprimé avec succès.');
        
        // Si on est en train d'éditer cette archive, mettre à jour le formulaire
        if (currentArchive && currentArchive.id === archiveId) {
          setArchiveForm({
            ...archiveForm,
            files: updatedFiles
          });
        }
        
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur: ${error.message}`);
      }
    }
  };
  const fetchStructureInfo = async () => {
    if (!currentUser) return;
    
    try {
      setLoading(true);
      const docRef = doc(db, "structures", currentUser.uid);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        setStructureInfo(docSnap.data());
      } else {
        console.error("Aucune information trouvée pour cette structure");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des informations de la structure:", error);
      toast.error("Impossible de charger les informations de la structure");
    } finally {
      setLoading(false);
    }
  };
  // Gestion des formulaires médecin
  const handleMedecinChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name === "assurances") {
      // Pour les checkboxes d'assurances
      const updatedArray = [...medecinForm.assurances];
      if (checked) {
        updatedArray.push(value);
      } else {
        const index = updatedArray.indexOf(value);
        if (index > -1) {
          updatedArray.splice(index, 1);
        }
      }
      setMedecinForm({ ...medecinForm, [name]: updatedArray });
    } else {
      setMedecinForm({ ...medecinForm, [name]: value });
    }
  };

  const handleDisponibiliteChange = (jour, field, value) => {
    setMedecinForm({
      ...medecinForm,
      disponibilites: {
        ...medecinForm.disponibilites,
        [jour]: {
          ...medecinForm.disponibilites[jour],
          [field]: field === 'actif' ? !medecinForm.disponibilites[jour].actif : value
        }
      }
    });
  };

  const resetMedecinForm = () => {
    setMedecinForm({
      nom: '',
      prenom: '',
      specialite: '',
      telephone: '',
      email: '',
      // Suppression du champ password
      disponibilites: {
        lundi: { actif: false, debut: '08:00', fin: '18:00' },
        mardi: { actif: false, debut: '08:00', fin: '18:00' },
        mercredi: { actif: false, debut: '08:00', fin: '18:00' },
        jeudi: { actif: false, debut: '08:00', fin: '18:00' },
        vendredi: { actif: false, debut: '08:00', fin: '18:00' },
        samedi: { actif: false, debut: '08:00', fin: '18:00' },
        dimanche: { actif: false, debut: '08:00', fin: '18:00' }
      },
      assurances: []
    });
    setCurrentMedecin(null);
  };

  const handleAddMedecin = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      let medecinAuthId;
      let generatedPassword = '';
      
      if (!currentMedecin) {
        generatedPassword = generateRandomPassword(12);
        // Utiliser la seconde instance d'authentification
        const userCredential = await createUserWithEmailAndPassword(
          secondaryAuth, 
          medecinForm.email, 
          generatedPassword
        );
        medecinAuthId = userCredential.user.uid;
        // Déconnecter immédiatement l'utilisateur de la seconde instance
        await signOut(secondaryAuth);
      }
      
      const disponibilitesAEnregistrer = [];
      Object.entries(medecinForm.disponibilites).forEach(([jour, valeur]) => {
        if (valeur.actif) {
          disponibilitesAEnregistrer.push({
            jour: jour.charAt(0).toUpperCase() + jour.slice(1),
            heureDebut: valeur.debut,
            heureFin: valeur.fin
          });
        }
      });
      
      const medecinData = {
        ...medecinForm,
        disponibilites: disponibilitesAEnregistrer,
        structureId: user.uid,
      };
      
      if (currentMedecin) {
        await updateDoc(doc(db, 'medecins', currentMedecin.id), {
          ...medecinData,
          updatedAt: new Date()
        });
        setMessage('Médecin mis à jour avec succès.');
      } else {
        await setDoc(doc(db, 'medecins', medecinAuthId), {
          ...medecinData,
          createdAt: new Date()
        });
        setMessage('Médecin ajouté avec succès.');
      }
      
      resetMedecinForm();
      setShowMedecinForm(false);
      fetchMedecins(user.uid);
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };
  

  const handleEditMedecin = (medecin) => {
    setCurrentMedecin(medecin);
    
    // Conversion des disponibilités du format stocké vers le format du formulaire
    let disponibilitesFormattees = {
      lundi: { actif: false, debut: '08:00', fin: '18:00' },
      mardi: { actif: false, debut: '08:00', fin: '18:00' },
      mercredi: { actif: false, debut: '08:00', fin: '18:00' },
      jeudi: { actif: false, debut: '08:00', fin: '18:00' },
      vendredi: { actif: false, debut: '08:00', fin: '18:00' },
      samedi: { actif: false, debut: '08:00', fin: '18:00' },
      dimanche: { actif: false, debut: '08:00', fin: '18:00' }
    };
    
    // Si le médecin a des disponibilités existantes, les convertir
    if (medecin.disponibilites && Array.isArray(medecin.disponibilites)) {
      medecin.disponibilites.forEach(dispo => {
        const jour = dispo.jour.toLowerCase();
        if (disponibilitesFormattees[jour]) {
          disponibilitesFormattees[jour] = {
            actif: true,
            debut: dispo.heureDebut || '08:00',
            fin: dispo.heureFin || '18:00'
          };
        }
      });
    } else if (medecin.disponibilites && typeof medecin.disponibilites === 'object') {
      // Si les disponibilités sont déjà au bon format
      disponibilitesFormattees = medecin.disponibilites;
    }
    
    setMedecinForm({
      nom: medecin.nom || '',
      prenom: medecin.prenom || '',
      specialite: medecin.specialite || '',
      telephone: medecin.telephone || '',
      email: medecin.email || '',
      password: '',  // Ne pas afficher le mot de passe existant
      disponibilites: disponibilitesFormattees,
      assurances: medecin.assurances || []
    });
    setShowMedecinForm(true);
  };

  const handleDeleteMedecin = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce médecin ?')) {
      try {
        await deleteDoc(doc(db, 'medecins', id));
        setMessage('Médecin supprimé avec succès.');
        const user = auth.currentUser;
        fetchMedecins(user.uid);
        
        // Faire disparaître le message après 3 secondes
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur lors de la suppression: ${error.message}`);
      }
    }
  };

  // Gestion des formulaires patient
  const handlePatientChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name === "assurances") {
      // Pour les checkboxes d'assurances
      const updatedArray = [...patientForm.assurances];
      if (checked) {
        updatedArray.push(value);
      } else {
        const index = updatedArray.indexOf(value);
        if (index > -1) {
          updatedArray.splice(index, 1);
        }
      }
      setPatientForm({ ...patientForm, [name]: updatedArray });
    } else {
      setPatientForm({ ...patientForm, [name]: value });
    }
  };

  const resetPatientForm = () => {
    setPatientForm({
      nom: '',
      prenom: '',
      dateNaissance: '',
      email: '',
      telephone: '',
      assurances: [],
      diagnostics: '' // Réinitialisation du champ diagnostics
    });
    setCurrentPatient(null);
  };



  const fetchQuickRequests = async (structureId) => {
    try {
      const q = query(
        collection(db, 'quickAppointments'),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      );
      const querySnapshot = await getDocs(q);
      const requests = [];
      querySnapshot.forEach((doc) => {
        requests.push({ id: doc.id, ...doc.data() });
      });
      setQuickRequests(requests);
      setQuickRequestsCount(requests.length);
    } catch (error) {
      console.error("Erreur lors de la récupération des demandes rapides:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const docRef = doc(db, 'structures', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setStructureData(docSnap.data());
          setForm(docSnap.data());
          fetchMedecins(user.uid);
          fetchPatients(user.uid);
          fetchRendezvous(user.uid);
          fetchArchives(user.uid);
          fetchPendingRequests(user.uid);
          fetchQuickRequests(user.uid); // Ajout de la récupération des demandes rapides
        }
      } else {
        navigate('/auth');
      }
    });
    return () => unsubscribe();
  }, [auth, navigate]);

  // Fonction pour accepter une demande de rendez-vous rapide
  const handleAcceptQuickRequest = async () => {
    try {
      if (!selectedQuickRequest || !selectedMedecinForQuick) {
        setMessage("Veuillez sélectionner un médecin pour ce rendez-vous.");
        return;
      }

      const user = auth.currentUser;
      const medecin = medecins.find(m => m.id === selectedMedecinForQuick);
      
      // Créer un nouveau rendez-vous à partir de la demande rapide
      const rdvData = {
        medecinId: selectedMedecinForQuick,
        medecinNom: `Dr. ${medecin.prenom} ${medecin.nom}`,
        medecinSpecialite: medecin.specialite,
        patientId: selectedQuickRequest.patientId || null,
        patientNom: `${selectedQuickRequest.prenom} ${selectedQuickRequest.nom}`,
        patientEmail: selectedQuickRequest.email,
        patientTelephone: selectedQuickRequest.telephone,
        date: selectedQuickRequest.dateFormatted,
        heure: selectedQuickRequest.heureRdv,
        duree: selectedQuickRequest.duree || "30",
        motif: selectedQuickRequest.motif || "Consultation",
        statut: "confirmé",
        structureId: user.uid,
        structureNom: selectedQuickRequest.structureNom || "",
        createdAt: new Date(),
        updatedAt: new Date(),
        source: "quick",
        verificationCode: selectedQuickRequest.verificationCode
      };

      // Ajouter le rendez-vous à la collection rendezvous
      const rdvRef = await addDoc(collection(db, 'rendezvous'), rdvData);
      
      // Mettre à jour le statut de la demande rapide
      await updateDoc(doc(db, 'quickAppointments', selectedQuickRequest.id), {
        status: "accepted",
        medecinId: selectedMedecinForQuick,
        medecinNom: `Dr. ${medecin.prenom} ${medecin.nom}`,
        rdvId: rdvRef.id,
        updatedAt: new Date()
      });

      // Envoyer une notification au patient (par email ou SMS si configuré)
      if (selectedQuickRequest.telephone) {
        try {
          const message = `Votre demande de rendez-vous a été acceptée. Dr. ${medecin.prenom} ${medecin.nom} vous recevra le ${selectedQuickRequest.dateFormatted} à ${selectedQuickRequest.heureRdv}. Votre code de vérification: ${selectedQuickRequest.verificationCode}`;
          await sendWhatsAppMessage(selectedQuickRequest.telephone, message);
        } catch (error) {
          console.error("Erreur lors de l'envoi du message WhatsApp:", error);
        }
      }

      setMessage("Demande de rendez-vous acceptée avec succès.");
      fetchQuickRequests(user.uid);
      fetchRendezvous(user.uid);
      setAssignMedecinModal(false);
      
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  // Fonction pour refuser une demande de rendez-vous rapide
  const handleRejectQuickRequest = async (requestId) => {
    if (window.confirm('Êtes-vous sûr de vouloir refuser cette demande de rendez-vous ?')) {
      try {
        const user = auth.currentUser;
        
        // Mettre à jour le statut de la demande rapide
        await updateDoc(doc(db, 'quickAppointments', requestId), {
          status: "rejected",
          updatedAt: new Date()
        });

        setMessage("Demande de rendez-vous refusée.");
        fetchQuickRequests(user.uid);
        
        // Faire disparaître le message après 3 secondes
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur: ${error.message}`);
      }
    }
  };

  // Ajouter un nouveau composant pour la section des demandes rapides
  const renderQuickRequestsSection = () => {
    return (
      <div className="card shadow-sm mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5>
            <FontAwesomeIcon icon={faCalendarPlus} className="me-2" />
            Demandes de rendez-vous rapides
            {quickRequestsCount > 0 && (
              <span className="badge bg-danger ms-2">{quickRequestsCount}</span>
            )}
          </h5>
          <Button 
            variant="primary" 
            size="sm"
            onClick={() => setShowQuickRequestsModal(true)}
          >
            Voir toutes les demandes
          </Button>
        </div>
        <div className="card-body">
          {quickRequests.length > 0 ? (
            <div className="quick-requests-preview">
             {quickRequests.slice(0, 3).map(request => (
  <div key={request.id} className="quick-request-item">
    <div className="d-flex justify-content-between align-items-center mb-2">
      <h6 className="mb-0">{request.prenom} {request.nom}</h6>
      <span className="badge bg-warning">En attente</span>
    </div>
    <div className="quick-request-details">
      <p><strong>Contact:</strong> {request.telephone}</p>
      {request.email && <p><strong>Email:</strong> {request.email}</p>}
      <p><strong>Date souhaitée:</strong> {request.dateFormatted}</p>
      <p><strong>Heure:</strong> {request.heureRdv}</p>
      {request.motif && <p><strong>Motif:</strong> {request.motif}</p>}
    </div>
    <div className="d-flex justify-content-end mt-2">
      <Button 
        variant="outline-danger" 
        size="sm" 
        className="me-2"
        onClick={() => handleRejectQuickRequest(request.id)}
      >
        <FontAwesomeIcon icon={faTimes} className="me-1" />
        Refuser
      </Button>
      <Button 
        variant="outline-success" 
        size="sm"
        onClick={() => {
          setSelectedQuickRequest(request);
          setAssignMedecinModal(true);
        }}
      >
        <FontAwesomeIcon icon={faCheck} className="me-1" />
        Accepter
      </Button>
    </div>
  </div>
))}

              {quickRequests.length > 3 && (
                <div className="text-center mt-3">
                  <Button 
                    variant="link" 
                    onClick={() => setShowQuickRequestsModal(true)}
                  >
                    Voir {quickRequests.length - 3} demandes supplémentaires
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <p className="text-center py-3 text-muted">Aucune demande de rendez-vous rapide en attente</p>
          )}
        </div>
      </div>
    );
  };




  // Fonction pour formater un numéro de téléphone au format international
const formatPhoneNumberForWhatsApp = (phoneNumber, countryCode = '221') => {
  // Supprimer les espaces, tirets et autres caractères non numériques
  let cleaned = phoneNumber.replace(/\D/g, '');
  
  // Si le numéro commence par un 0, le remplacer par le code pays
  if (cleaned.startsWith('0')) {
    cleaned = '+' + countryCode + cleaned.substring(1);
  } 
  // Si le numéro ne commence pas par un +, ajouter le +
  else if (!cleaned.startsWith('+')) {
    cleaned = '+' + cleaned;
  }
  
  return cleaned;
};

// Fonction améliorée pour envoyer un message WhatsApp avec gestion des erreurs
const sendWhatsAppMessageWithRetry = async (phoneNumber, message, maxRetries = 3) => {
  let retries = 0;
  let success = false;
  let lastError = null;
  
  while (retries < maxRetries && !success) {
    try {
      await sendWhatsAppMessage(phoneNumber, message);
      success = true;
    } catch (error) {
      lastError = error;
      retries++;
      
      // Attendre avant de réessayer (backoff exponentiel)
      if (retries < maxRetries) {
        await new Promise(resolve => setTimeout(resolve, 1000 * Math.pow(2, retries)));
      }
    }
  }
  
  if (!success) {
    console.error(`Échec de l'envoi du message WhatsApp après ${maxRetries} tentatives:`, lastError);
    // Enregistrer l'échec pour une tentative ultérieure
    await addDoc(collection(db, 'failedWhatsAppMessages'), {
      phoneNumber,
      message,
      createdAt: new Date(),
      error: lastError?.message || 'Unknown error'
    });
    throw new Error(`Impossible d'envoyer le message WhatsApp. Il sera réessayé plus tard.`);
  }
  
  return success;
};


// Fonction pour traiter les messages WhatsApp en échec
const processFailedWhatsAppMessages = async () => {
  try {
    const failedMessagesQuery = query(collection(db, 'failedWhatsAppMessages'), 
      where('retryCount', '<', 5));
    
    const snapshot = await getDocs(failedMessagesQuery);
    
    for (const doc of snapshot.docs) {
      const messageData = doc.data();
      try {
        await sendWhatsAppMessage(messageData.phoneNumber, messageData.message);
        
        // Message envoyé avec succès, supprimer de la file d'attente
        await deleteDoc(doc.ref);
        
        console.log(`Message en échec envoyé avec succès: ${doc.id}`);
      } catch (error) {
        // Incrémenter le compteur de tentatives
        await updateDoc(doc.ref, {
          retryCount: (messageData.retryCount || 0) + 1,
          lastRetry: new Date(),
          lastError: error.message
        });
        
        console.error(`Échec de l'envoi du message ${doc.id}:`, error);
      }
    }
  } catch (error) {
    console.error('Erreur lors du traitement des messages en échec:', error);
  }
};

// Exécuter le traitement des messages en échec périodiquement
useEffect(() => {
  const intervalId = setInterval(processFailedWhatsAppMessages, 15 * 60 * 1000); // Toutes les 15 minutes
  
  return () => clearInterval(intervalId);
}, []);


// Fonction pour afficher une notification plus détaillée
const showNotification = (message, type = 'success', duration = 5000) => {
  setMessage({
    text: message,
    type: type
  });
  
  setTimeout(() => setMessage(''), duration);
};




// Fonction pour créer un template de message de bienvenue
const createWelcomeTemplate = (firstName, lastName, email, password, isDoctor = false) => {
  const title = isDoctor ? `Dr. ${firstName} ${lastName}` : `${firstName} ${lastName}`;
  
  return {
    to_number: phoneNumber,
    type: "template",
    message: "welcome_message",
    params: [
      title,
      email,
      password
    ]
  };
};

// Utilisation avec l'API Maytapi pour les templates
const sendWhatsAppTemplate = async (phoneNumber, templateData) => {
  try {
    const response = await axios({
      method: 'post',
      url: `https://api.maytapi.com/api/${MAYTAPI_PRODUCT_ID}/${MAYTAPI_PHONE_ID}/sendTemplate`,
      headers: {
        'Content-Type': 'application/json',
        'x-maytapi-key': MAYTAPI_API_TOKEN
      },
      data: {
        to_number: phoneNumber,
        ...templateData
      }
    });
    
    console.log('Template WhatsApp envoyé avec succès:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'envoi du template WhatsApp:', error);
    throw error;
  }
};



  const handleAddPatient = async (e) => {
    e.preventDefault();
    // Vérification : seul le numéro de téléphone doit être obligatoire
    if (!patientForm.telephone) {
      setMessage("Le numéro de téléphone est obligatoire.");
      return;
    }
    try {
      const user = auth.currentUser;
      let patientAuthId; // undefined tant qu'aucun compte Firebase n'est créé
      let generatedPassword = '';
      const shouldCreateAuthUser = patientForm.email && patientForm.email.trim() !== '';

      if (!currentPatient && shouldCreateAuthUser) {
        generatedPassword = generateRandomPassword(12);
        const userCredential = await createUserWithEmailAndPassword(
          secondaryAuth,
          patientForm.email,
          generatedPassword
        );
        patientAuthId = userCredential.user.uid;
        await signOut(secondaryAuth);

        // Envoi d'un message WhatsApp de bienvenue uniquement si un compte a été créé
        let phoneNumber = patientForm.telephone;
        if (!phoneNumber.startsWith('+')) {
          phoneNumber = '+221' + phoneNumber.substring(1);
        }
        const welcomeMessage =
          `Bonjour ${patientForm.prenom || ''} ${patientForm.nom || ''},\n\n` +
          `Bienvenue sur notre plateforme de gestion médicale !\n\n` +
          `Voici vos informations de connexion :\n` +
          `Email: ${patientForm.email}\n` +
          `Mot de passe: ${generatedPassword}\n\n` +
          `Nous vous recommandons de changer votre mot de passe après votre première connexion.`;
        try {
          await sendWhatsAppMessage(phoneNumber, welcomeMessage);
        } catch (error) {
          console.error("Erreur lors de l'envoi du message WhatsApp:", error);
        }
      }

      const patientData = {
        ...patientForm,
        structureId: user.uid,
      };

      if (currentPatient) {
        await updateDoc(doc(db, 'patients', currentPatient.id), {
          ...patientData,
          updatedAt: new Date(),
        });
        setMessage('Patient mis à jour avec succès.');
      } else {
        if (patientAuthId) {
          await setDoc(doc(db, 'patients', patientAuthId), {
            ...patientData,
            createdAt: new Date(),
          });
        } else {
          // Aucun compte Firebase – on laisse Firestore générer l'ID
          await addDoc(collection(db, 'patients'), {
            ...patientData,
            createdAt: new Date(),
          });
        }
        setMessage('Patient ajouté avec succès.');
      }

      resetPatientForm();
      setShowPatientForm(false);
      fetchPatients(user.uid);
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };
  
  

  const handleEditPatient = (patient) => {
    setCurrentPatient(patient);
    setPatientForm({
      nom: patient.nom || '',
      prenom: patient.prenom || '',
      dateNaissance: patient.dateNaissance || '',
      email: patient.email || '',
      password: '',  // Ne pas afficher le mot de passe existant
      telephone: patient.telephone || '',
      assurances: patient.assurances || [],
      diagnostics: patient.diagnostics || '' // Ajout du champ diagnostics
    });
    setShowPatientForm(true);
  };

  const handleDeletePatient = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce patient ?')) {
      try {
        await deleteDoc(doc(db, 'patients', id));
        setMessage('Patient supprimé avec succès.');
        const user = auth.currentUser;
        fetchPatients(user.uid);
        
        // Faire disparaître le message après 3 secondes
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur lors de la suppression: ${error.message}`);
      }
    }
  };

  // Gestion des formulaires rendez-vous
  const handleRdvChange = (e) => {
    const { name, value } = e.target;
    setRdvForm({ ...rdvForm, [name]: value });
  };

  const resetRdvForm = () => {
    setRdvForm({
      medecinId: '',
      patientId: '',
      date: new Date().toISOString().split('T')[0],
      heure: '08:00',
      duree: 15,
      motif: '',
      statut: 'confirmé'
    });
    setCurrentRendezvous(null);
  };

// Vérifier si l'heure de rendez-vous est disponible
const verifierDisponibilite = (medecinId, date, heure, duree, rdvIdAExclure = null) => {
  // Trouver le médecin
  const medecin = medecins.find(m => m.id === medecinId);
  if (!medecin) return false;
  
  // Vérifier le jour de la semaine
  const jourDate = new Date(date);
  const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  const jourSemaine = joursMap[jourDate.getDay()];
  
  // Vérifier si le médecin travaille ce jour-là
  let disponibiliteJour = null;
  if (Array.isArray(medecin.disponibilites)) {
    disponibiliteJour = medecin.disponibilites.find(d => 
      d.jour.toLowerCase() === jourSemaine.toLowerCase()
    );
  } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
    disponibiliteJour = medecin.disponibilites[jourSemaine].actif ? {
      heureDebut: medecin.disponibilites[jourSemaine].debut,
      heureFin: medecin.disponibilites[jourSemaine].fin
    } : null;
  }
  
  if (!disponibiliteJour) return false;
  
  // Vérifier si l'heure est dans la plage de disponibilité
  const heureDebut = disponibiliteJour.heureDebut || disponibiliteJour.debut;
  const heureFin = disponibiliteJour.heureFin || disponibiliteJour.fin;
  
  if (heure < heureDebut || heure > heureFin) return false;
  
  // Calculer l'heure de fin du rendez-vous
  const [heureH, heureM] = heure.split(':').map(Number);
  const heureFinRdv = new Date();
  heureFinRdv.setHours(heureH, heureM + parseInt(duree), 0, 0);
  const heureFinStr = `${heureFinRdv.getHours().toString().padStart(2, '0')}:${heureFinRdv.getMinutes().toString().padStart(2, '0')}`;
  
  if (heureFinStr > heureFin) return false;
  
  // Vérifier les chevauchements avec d'autres rendez-vous
  const rdvDuJour = rendezvous.filter(rdv => 
    rdv.medecinId === medecinId && 
    rdv.date === date && 
    rdv.statut !== 'annulé' &&
    rdv.id !== rdvIdAExclure
  );
  
  // Compter les rendez-vous à cette heure précise
  const rdvAuCreneau = rdvDuJour.filter(rdv => rdv.heure === heure);
  
  // Nombre maximum de rendez-vous simultanés autorisés
  const MAX_RDV_SIMULTANES = 3;
  
  // Si nous avons déjà atteint le nombre maximum de rendez-vous à cette heure
  if (rdvAuCreneau.length >= MAX_RDV_SIMULTANES) {
    return false;
  }
  
  return true;
};



  const handleAddRendezvous = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      
      // Vérifier la disponibilité
      const estDisponible = verifierDisponibilite(
        rdvForm.medecinId, 
        rdvForm.date, 
        rdvForm.heure, 
        rdvForm.duree,
        currentRendezvous?.id
      );
      
      if (!estDisponible) {
        setMessage("Erreur: Le médecin n'est pas disponible à cette heure ou il y a un conflit d'horaire.");
        return;
      }
      
      // Normaliser la date
      const dateObj = new Date(rdvForm.date);
      const normalizedDate = formatDateString(dateObj);
      
      const rdvData = {
        ...rdvForm,
        date: normalizedDate,
        structureId: user.uid,
      };
      
      // Récupérer les informations du médecin et du patient pour les stocker dans le rendez-vous
      const medecin = medecins.find(m => m.id === rdvForm.medecinId);
      const patient = patients.find(p => p.id === rdvForm.patientId);
      
      if (medecin) {
        rdvData.medecinNom = `${medecin.prenom} ${medecin.nom}`;
        rdvData.medecinSpecialite = medecin.specialite;
      }
      
      if (patient) {
        rdvData.patientNom = `${patient.prenom} ${patient.nom}`;
      }
      
      if (currentRendezvous) {
        // Modification d'un rendez-vous existant
        await updateDoc(doc(db, 'rendezvous', currentRendezvous.id), {
          ...rdvData,
          updatedAt: new Date()
        });
        setMessage('Rendez-vous mis à jour avec succès.');
      } else {
        // Création d'un nouveau rendez-vous
        await addDoc(collection(db, 'rendezvous'), {
          ...rdvData,
          createdAt: new Date()
        });
        setMessage('Rendez-vous ajouté avec succès.');
      }
      
      resetRdvForm();
      setShowRendezvousForm(false);
      fetchRendezvous(user.uid);
      
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  



  const handleEditRendezvous = (rdv) => {
    setCurrentRendezvous(rdv);
    setRdvForm({
      medecinId: rdv.medecinId || '',
      patientId: rdv.patientId || '',
      date: rdv.date || new Date().toISOString().split('T')[0],
      heure: rdv.heure || '08:00',
      duree: rdv.duree || '',
      motif: rdv.motif || '',
      statut: rdv.statut || 'confirmé'
    });
    setShowRendezvousForm(true);
  };

  const handleDeleteRendezvous = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce rendez-vous ?')) {
      try {
        await deleteDoc(doc(db, 'rendezvous', id));
        setMessage('Rendez-vous supprimé avec succès.');
        const user = auth.currentUser;
        fetchRendezvous(user.uid);
        
        // Faire disparaître le message après 3 secondes
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur lors de la suppression: ${error.message}`);
      }
    }
  };

  const handleChangeStatutRendezvous = async (id, nouveauStatut) => {
    try {
      await updateDoc(doc(db, 'rendezvous', id), {
        statut: nouveauStatut,
        updatedAt: new Date()
      });
      setMessage('Statut du rendez-vous mis à jour avec succès.');
      const user = auth.currentUser;
      fetchRendezvous(user.uid);
      
      // Faire disparaître le message après 3 secondes
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur lors de la mise à jour du statut: ${error.message}`);
    }
  };

  // Filtrer les rendez-vous par date et médecin
  const rendezVousFiltres = rendezvous.filter(rdv => {
    let correspondDate = true;
    let correspondMedecin = true;
    
    if (filtreDate) {
      correspondDate = rdv.date === filtreDate;
    }
    
    if (filtreMedecin) {
      correspondMedecin = rdv.medecinId === filtreMedecin;
    }
    
    return correspondDate && correspondMedecin;
  });

  // Trier les rendez-vous par heure
  rendezVousFiltres.sort((a, b) => {
    if (a.date !== b.date) {
      return a.date.localeCompare(b.date);
    }
    return a.heure.localeCompare(b.heure);
  });

  // Fonction pour obtenir les créneaux disponibles
  const getCreneauxDisponibles = () => {
    if (!rdvForm.medecinId || !rdvForm.date) return [];
    
    const medecin = medecins.find(m => m.id === rdvForm.medecinId);
    if (!medecin) return [];
    
    // Déterminer le jour de la semaine
    const jourDate = new Date(rdvForm.date);
    const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    const jourSemaine = joursMap[jourDate.getDay()];
    
    // Obtenir les horaires du médecin pour ce jour
    let heureDebut = '08:00';
    let heureFin = '18:00';
    
    if (Array.isArray(medecin.disponibilites)) {
      const disponibiliteJour = medecin.disponibilites.find(d => 
        d.jour.toLowerCase() === jourSemaine.toLowerCase()
      );
      
      if (disponibiliteJour) {
        heureDebut = disponibiliteJour.heureDebut;
        heureFin = disponibiliteJour.heureFin;
      } else {
        return []; // Le médecin ne travaille pas ce jour
      }
    } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
      if (!medecin.disponibilites[jourSemaine].actif) {
        return []; // Le médecin ne travaille pas ce jour
      }
      heureDebut = medecin.disponibilites[jourSemaine].debut;
      heureFin = medecin.disponibilites[jourSemaine].fin;
    } else {
      return []; // Pas de disponibilités pour ce jour
    }
    
    // Générer des créneaux de 15 minutes
    const creneaux = [];
    let heure = heureDebut;
    
    while (heure < heureFin) {
      const [h, m] = heure.split(':').map(Number);
      const heureFinCreneau = new Date();
      heureFinCreneau.setHours(h, m + parseInt(rdvForm.duree), 0, 0);
      const heureFinStr = `${heureFinCreneau.getHours().toString().padStart(2, '0')}:${heureFinCreneau.getMinutes().toString().padStart(2, '0')}`;
      
      if (heureFinStr <= heureFin) {
        // Vérifier si le créneau est disponible (pas de chevauchement avec d'autres RDV)
        const estDisponible = verifierDisponibilite(
          rdvForm.medecinId, 
          rdvForm.date, 
          heure, 
          rdvForm.duree,
          currentRendezvous?.id
        );
        
        if (estDisponible) {
          creneaux.push(heure);
        }
      }
      
      // Passer au créneau suivant (par tranches de 15 minutes)
      const nextHeure = new Date();
      nextHeure.setHours(h, m + 15, 0, 0);
      heure = `${nextHeure.getHours().toString().padStart(2, '0')}:${nextHeure.getMinutes().toString().padStart(2, '0')}`;
    }
    
    return creneaux;
  };

  // Fonction pour basculer l'état du menu latéral
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  // Fonctions pour la vue calendrier
  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };




 



  const handleDateClick = (day) => {
    if (day.hasEvents) {
      setSelectedDate(day);
      setShowDateModal(true);
    }
  };

  const handleMedecinClick = (medecinId) => {
    setSelectedMedecinId(medecinId);
    setShowMedecinRdvModal(true);
    setShowDateModal(false);
  };

  const handleRdvClick = (rdv) => {
    setSelectedRdv(rdv);
    setShowRdvDetailsModal(true);
  };

  const handleDragStart = (rdv) => {
    setDraggedRdv(rdv);
  };

  const handleDrop = async (targetRdv) => {
    if (!draggedRdv || draggedRdv.id === targetRdv.id) return;
    
    try {
      // Échanger les heures des rendez-vous
      const draggedHeure = draggedRdv.heure;
      const targetHeure = targetRdv.heure;
      
      await updateDoc(doc(db, 'rendezvous', draggedRdv.id), {
        heure: targetHeure,
        updatedAt: new Date()
      });
      
      await updateDoc(doc(db, 'rendezvous', targetRdv.id), {
        heure: draggedHeure,
        updatedAt: new Date()
      });
      
      setMessage('Rendez-vous échangés avec succès.');
      const user = auth.currentUser;
      fetchRendezvous(user.uid);
      
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur lors de l'échange: ${error.message}`);
    }
    
    setDraggedRdv(null);
  };

  const handlePrevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };
  const getMedecinsByDate = (date) => {
    const dateString = date.dateString || formatDateString(date.date);
    const rdvs = rendezvous.filter(rdv => rdv.date === dateString);
    const uniqueMedecinIds = [...new Set(rdvs.map(rdv => rdv.medecinId))];
    
    return uniqueMedecinIds.map(id => {
      const medecin = medecins.find(m => m.id === id);
      const medecinRdvs = rdvs.filter(rdv => rdv.medecinId === id);
      
      return {
        medecin: medecin,
        rdvCount: medecinRdvs.length
      };
    });
  };


const getMedecinRdvs = (medecinId, date) => {
  // Utiliser la date normalisée stockée dans l'objet day
  const dateString = date.dateString || formatDateString(date.date);
  
  return rendezvous
    .filter(rdv => rdv.medecinId === medecinId && rdv.date === dateString)
    .sort((a, b) => a.heure.localeCompare(b.heure));
};


// Fonction pour obtenir tous les créneaux avec leur statut (disponible, partiellement occupé ou complet)
const getCreneauxAvecStatut = () => {
  if (!rdvForm.medecinId || !rdvForm.date) return [];
  
  const medecin = medecins.find(m => m.id === rdvForm.medecinId);
  if (!medecin) return [];
  
  // Déterminer le jour de la semaine
  const jourDate = new Date(rdvForm.date);
  const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  const jourSemaine = joursMap[jourDate.getDay()];
  
  // Obtenir les horaires du médecin pour ce jour
  let heureDebut = '08:00';
  let heureFin = '18:00';
  let disponibiliteJour = null;
  
  if (Array.isArray(medecin.disponibilites)) {
    disponibiliteJour = medecin.disponibilites.find(d => 
      d.jour.toLowerCase() === jourSemaine.toLowerCase()
    );
    
    if (disponibiliteJour) {
      heureDebut = disponibiliteJour.heureDebut;
      heureFin = disponibiliteJour.heureFin;
    } else {
      return []; // Le médecin ne travaille pas ce jour
    }
  } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
    if (!medecin.disponibilites[jourSemaine].actif) {
      return []; // Le médecin ne travaille pas ce jour
    }
    heureDebut = medecin.disponibilites[jourSemaine].debut;
    heureFin = medecin.disponibilites[jourSemaine].fin;
  } else {
    return []; // Pas de disponibilités pour ce jour
  }
  
  // Récupérer les rendez-vous existants pour ce médecin et cette date
  const rdvDuJour = rendezvous.filter(rdv => 
    rdv.medecinId === rdvForm.medecinId && 
    rdv.date === rdvForm.date && 
    rdv.statut !== 'annulé' &&
    rdv.id !== currentRendezvous?.id
  );
  
  // Générer tous les créneaux possibles (par tranches de 15 minutes)
  const tousLesCreneaux = [];
  let heure = heureDebut;
  
  // Nombre maximum de rendez-vous simultanés autorisés
  const MAX_RDV_SIMULTANES = 3;
  
  while (heure < heureFin) {
    const [h, m] = heure.split(':').map(Number);
    const heureFinCreneau = new Date();
    heureFinCreneau.setHours(h, m + parseInt(rdvForm.duree), 0, 0);
    const heureFinStr = `${heureFinCreneau.getHours().toString().padStart(2, '0')}:${heureFinCreneau.getMinutes().toString().padStart(2, '0')}`;
    
    if (heureFinStr <= heureFin) {
      // Compter le nombre de rendez-vous à cette heure
      const rdvAuCreneau = rdvDuJour.filter(rdv => rdv.heure === heure);
      const nombreRdvAuCreneau = rdvAuCreneau.length;
      
      // Déterminer le statut du créneau
      let statut = 'disponible';
      if (nombreRdvAuCreneau >= MAX_RDV_SIMULTANES) {
        statut = 'complet';
      } else if (nombreRdvAuCreneau > 0) {
        statut = 'partiel';
      }
      
      tousLesCreneaux.push({
        heure: heure,
        statut: statut,
        nombreRdv: nombreRdvAuCreneau,
        estDisponible: statut !== 'complet'
      });
    }
    
    // Passer au créneau suivant (par tranches de 15 minutes)
    const nextHeure = new Date();
    nextHeure.setHours(h, m + 15, 0, 0);
    heure = `${nextHeure.getHours().toString().padStart(2, '0')}:${nextHeure.getMinutes().toString().padStart(2, '0')}`;
  }
  
  return tousLesCreneaux;
};



  const handleMobileTabChange = (tab) => {
    setActiveTab(tab);
    setShowMobileMenu(false);
    setMobileDetailView(null);
  };

  const handleMobileDetailView = (type, item) => {
    setMobileDetailView({ type, item });
  };

  const handleBackToList = () => {
    setMobileDetailView(null);
  };

  const handleMobileSearch = (e) => {
    setMobileSearchQuery(e.target.value);
  };

  const filteredMedecins = mobileSearchActive && mobileSearchQuery 
    ? medecins.filter(m => 
        `${m.nom} ${m.prenom}`.toLowerCase().includes(mobileSearchQuery.toLowerCase()) ||
        m.specialite.toLowerCase().includes(mobileSearchQuery.toLowerCase())
      )
    : medecins;

  const filteredPatients = mobileSearchActive && mobileSearchQuery 
    ? patients.filter(p => 
        `${p.nom} ${p.prenom}`.toLowerCase().includes(mobileSearchQuery.toLowerCase())
      )
    : patients;

  const filteredRendezvous = mobileSearchActive && mobileSearchQuery 
    ? rendezvous.filter(r => 
        r.patientNom?.toLowerCase().includes(mobileSearchQuery.toLowerCase()) ||
        r.medecinNom?.toLowerCase().includes(mobileSearchQuery.toLowerCase())
      )
    : rendezvous;

    
    // Fonction pour accepter une demande de rendez-vous
const handleAccepterDemandeRapide = async (demande) => {
  if (!currentUser) return;

  try {
    setLoading(true);
    
    // Chercher si le patient existe déjà
    const patientQuery = query(
      collection(db, 'patients'),
      where("structureId", "==", demande.structureId),
      where("telephone", "==", demande.telephone)
    );
    const patientSnapshot = await getDocs(patientQuery);
    
    let patientId = null;
    
    // Si le patient n'existe pas encore, le créer
    if (patientSnapshot.empty) {
      const patientData = {
        nom: demande.nom,
        prenom: demande.prenom,
        dateNaissance: demande.dateNaissance || '',
        email: demande.email || '',
        telephone: demande.telephone,
        structureId: demande.structureId,
        createdAt: new Date(),
        assurances: [],
        diagnostics: '' // Ajout du champ diagnostics
      };
      
      const docRef = await addDoc(collection(db, 'patients'), patientData);
      patientId = docRef.id;
    } else {
      patientId = patientSnapshot.docs[0].id;
    }
    
    // Mettre à jour le rendez-vous
    await updateDoc(doc(db, 'rendezvous', demande.id), {
      statut: 'confirmé',
      patientId: patientId
    });
    
    // Envoyer notification WhatsApp si configuré
    if (demande.telephone) {
      try {
        const structureDoc = await getDoc(doc(db, 'structures', demande.structureId));
        const structureData = structureDoc.exists() ? structureDoc.data() : null;
        
        const message = `Votre rendez-vous chez ${structureData.nom || 'notre établissement'} a été confirmé.\n\n` +
                      `Date: ${formatDate(demande.date)}\n` +
                      `Heure: ${demande.heure}\n` +
                      `Médecin: ${demande.medecinNom || ''}\n\n` +
                      `Votre code de vérification est: ${demande.verificationCode}\n\n` +
                      `Veuillez vous présenter 10 minutes avant l'heure de votre rendez-vous.`;
        
        await sendWhatsAppMessage(demande.telephone, message);
      } catch (error) {
        console.error("Erreur lors de l'envoi du message WhatsApp:", error);
      }
    }
    
    // Rafraîchir les données
    fetchDemandesRapides();
    fetchRendezvous(currentUser.uid);
    
    toast.success("La demande a été acceptée avec succès !");
  } catch (error) {
    console.error("Erreur lors de l'acceptation de la demande:", error);
    toast.error(`Erreur: ${error.message}`);
  } finally {
    setLoading(false);
  }
};

// Fonction pour récupérer les demandes rapides
const fetchDemandesRapides = async () => {
  if (!currentUser) return;

  try {
    setLoading(true);
    const q = query(
      collection(db, 'rendezvous'),
      where("structureId", "==", currentUser.uid),
      where("statut", "==", "confirmé"),
      where("source", "==", "quick")
    );
    
    const querySnapshot = await getDocs(q);
    const demandes = [];
    
    querySnapshot.forEach((doc) => {
      demandes.push({ id: doc.id, ...doc.data() });
    });
    
    setDemandesRapides(demandes);
  } catch (error) {
    console.error("Erreur lors de la récupération des demandes rapides:", error);
    toast.error("Impossible de charger les demandes rapides");
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  const auth = getAuth();
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    setCurrentUser(user);
  });
  
  // Nettoyer l'abonnement lors du démontage du composant
  return () => unsubscribe();
}, []);

// Modifier useEffect pour charger les demandes rapides
useEffect(() => {
  if (currentUser) {
    fetchStructureInfo();
    fetchRendezvous(currentUser.uid);
    fetchDemandesRapides();
    fetchPatients(currentUser.uid);
    fetchMedecins(currentUser.uid);
  }
}, [currentUser]);


// Fonction pour refuser une demande rapide
const handleRefuserDemandeRapide = async (demandeId) => {
  try {
    setLoading(true);
    
    // Mettre à jour le statut du rendez-vous à "refusé"
    await updateDoc(doc(db, 'rendezvous', demandeId), {
      statut: 'refusé'
    });
    
    // Rafraîchir les données
    fetchDemandesRapides();
    
    toast.success("La demande rapide a été refusée.");
  } catch (error) {
    console.error("Erreur lors du refus de la demande rapide:", error);
    toast.error(`Erreur: ${error.message}`);
  } finally {
    setLoading(false);
  }
};

  // Composant pour afficher les demandes rapides
  const RenderDemandesRapides = () => {
    const [activeTab, setActiveTabRdv] = useState('tous'); // 'tous' pour voir toutes les demandes
    const [demandesRapides, setDemandesRapides] = useState([]);
    const [loading, setLoading] = useState(false);

    // Fonction pour récupérer toutes les demandes rapides
    const fetchDemandesRapides = async () => {
      if (!currentUser) return;

      try {
        setLoading(true);
        const q = query(
          collection(db, 'rendezvous'),
          where("structureId", "==", currentUser.uid),
          where("source", "==", "quick"),
          orderBy("createdAt", "desc") // Pour avoir les plus récentes en premier
        );
        
        const querySnapshot = await getDocs(q);
        const demandes = [];
        
        querySnapshot.forEach((doc) => {
          demandes.push({ id: doc.id, ...doc.data() });
        });
        
        setDemandesRapides(demandes);
      } catch (error) {
        console.error("Erreur lors de la récupération des demandes rapides:", error);
        toast.error("Impossible de charger les demandes rapides");
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchDemandesRapides();
    }, [currentUser]);

    return (
      <div className="demandes-rapides-section">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4>
            <FontAwesomeIcon icon={faBolt} className="me-2 text-warning" />
            Demandes de rendez-vous rapides
          </h4>
          <button 
            className="btn btn-sm btn-outline-primary" 
            onClick={fetchDemandesRapides}
            disabled={loading}
          >
            {loading ? 
              <FontAwesomeIcon icon={faSpinner} spin /> : 
              <FontAwesomeIcon icon={faSync} />} Actualiser
          </button>
        </div>

        {loading ? (
          <div className="text-center my-4">
            <FontAwesomeIcon icon={faSpinner} spin size="2x" />
            <p className="mt-2">Chargement des demandes...</p>
          </div>
        ) : demandesRapides.length === 0 ? (
          <div className="alert alert-info">
            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
            Aucune demande de rendez-vous rapide.
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover">
              <thead className="table-light">
                <tr>
                  <th>Date de demande</th>
                  <th>Patient</th>
                  <th>Contact</th>
                  <th>Date souhaitée</th>
                  <th>Heure</th>
                  <th>Motif</th>
                  <th>Code de vérification</th>
                  <th>Statut</th>
                </tr>
              </thead>
              <tbody>
              {demandesRapides.map((demande) => {
  console.log('Données de la demande:', demande);
  console.log('Date formatée:', demande.dateFormatted || demande.date);
  console.log('Heure du RDV:', demande.heureRdv || demande.heure);
  console.log('Informations patient:', {
    nom: demande.patientNom || demande.nom,  // Ajout de patientNom comme alternative
    prenom: demande.patientPrenom || demande.prenom,  // Ajout de patientPrenom comme alternative
    telephone: demande.patientTelephone || demande.telephone,  // Ajout de patientTelephone comme alternative
    email: demande.patientEmail || demande.email  // Utilisation de patientEmail qui est présent dans les données
  });
  console.log('Statut de la demande:', demande.statut);
  console.log('Code de vérification:', demande.verificationCode);
  
  return (
    <tr key={demande.id}>
      <td>{new Date(demande.createdAt?.toDate()).toLocaleString()}</td>
      <td>
        <div className="fw-bold">
          {(demande.patientPrenom || demande.prenom)} {(demande.patientNom || demande.nom)}
        </div>
        <div className="small text-muted">
          {demande.dateNaissance && `Né(e) le ${formatDate(demande.dateNaissance)}`}
        </div>
      </td>
      <td>
        <div>{demande.patientTelephone || demande.telephone}</div>
        <div className="small text-muted">{demande.patientEmail || demande.email}</div>
      </td>
      <td>{formatDate(demande.dateRdv || demande.date)}</td>
      <td>{demande.heureRdv || demande.heure}</td>
      <td>
        <span 
          className="text-truncate d-inline-block" 
          style={{maxWidth: "150px"}} 
          title={demande.motif}
        >
          {demande.motif || <span className="text-muted">Non spécifié</span>}
        </span>
      </td>
      <td>
        <span className="badge bg-info">
          {demande.verificationCode}
        </span>
      </td>
      <td>
        <span className={`badge ${
          demande.statut === 'confirmé' ? 'bg-success' : 
          demande.statut === 'en attente' ? 'bg-warning' :
          demande.statut === 'annulé' ? 'bg-danger' : 'bg-secondary'
        }`}>
          {demande.statut}
        </span>
      </td>
    </tr>
  );
})}

              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };


// Fin des composants pour les demandes rapides




useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    if (user) {
      const docRef = doc(db, 'structures', user.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setStructureData(docSnap.data());
        // Autres appels pour récupérer les données
      } else {
        navigate('/auth');
      }
    } else {
      navigate('/auth');
    }
  });
  return () => unsubscribe();
}, [auth, navigate]);


const StructureDashboardMobile = () => {
  const [structureData, setStructureData] = useState(null);
  const [activeTab, setActiveTab] = useState('rendezvous');
  const [medecins, setMedecins] = useState([]);
  const [patients, setPatients] = useState([]);
  const [rendezvous, setRendezvous] = useState([]);
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showDetailsView, setShowDetailsView] = useState(null);
  const [currentMedecin, setCurrentMedecin] = useState(null);
  const [currentPatient, setCurrentPatient] = useState(null);
  const [currentRendezvous, setCurrentRendezvous] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [quickRequestsCount, setQuickRequestsCount] = useState(0);
  const [demandesRapides, setDemandesRapides] = useState([]);
  const [pendingDoctorRequests, setPendingDoctorRequests] = useState([]);
  const [affiliationRequests, setAffiliationRequests] = useState([]);
  const [showDateRdvs, setShowDateRdvs] = useState(false);
  const [selectedMedecinId, setSelectedMedecinId] = useState(null);
  const [showMedecinRdvs, setShowMedecinRdvs] = useState(false);

  // Formulaires
  const [medecinForm, setMedecinForm] = useState({
    nom: '',
    prenom: '',
    specialite: '',
    telephone: '',
    email: '',
    disponibilites: {
      lundi: { actif: false, debut: '08:00', fin: '18:00' },
      mardi: { actif: false, debut: '08:00', fin: '18:00' },
      mercredi: { actif: false, debut: '08:00', fin: '18:00' },
      jeudi: { actif: false, debut: '08:00', fin: '18:00' },
      vendredi: { actif: false, debut: '08:00', fin: '18:00' },
      samedi: { actif: false, debut: '08:00', fin: '18:00' },
      dimanche: { actif: false, debut: '08:00', fin: '18:00' }
    },
    assurances: []
  });
  
  const [patientForm, setPatientForm] = useState({
    nom: '',
    prenom: '',
    dateNaissance: '',
    email: '',
    telephone: '',
    assurances: [],
    diagnostics: '' // Ajout du champ diagnostics
  });
  
  const [rdvForm, setRdvForm] = useState({
    medecinId: '',
    patientId: '',
    date: new Date().toISOString().split('T')[0],
    heure: '08:00',
    motif: '',
    statut: 'confirmé'
  });

  // Constantes
  const specialites = ["Généraliste", "Cardiologue", "Dermatologue", "Pédiatre", "Gynécologue", "Ophtalmologue", "Autre"];
  const assurancesList = ["CNAM", "CNSS", "CNRPS", "Assurance privée", "Autre"];
  const joursSemaine = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"];
  const statutsRdv = ["confirmé", "terminé", "annulé"];
  
  const navigate = useNavigate();
  const auth = getAuth();
  const storage = getStorage();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const docRef = doc(db, 'structures', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setStructureData(docSnap.data());
          setForm(docSnap.data());
          fetchMedecins(user.uid);
          fetchPatients(user.uid);
          fetchRendezvous(user.uid);
          fetchPendingRequests(user.uid);
          fetchQuickRequests(user.uid);
        }
        setLoading(false);
      } else {
        navigate('/auth');
      }
    });
    return () => unsubscribe();
  }, [auth, navigate]);

  // Fonctions de récupération de données
  const fetchMedecins = async (structureId) => {
    try {
      const q = query(collection(db, 'medecins'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      const medecinsData = [];
      querySnapshot.forEach((doc) => {
        medecinsData.push({ id: doc.id, ...doc.data() });
      });
      setMedecins(medecinsData);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const fetchPatients = async (structureId) => {
    try {
      const q = query(collection(db, 'patients'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      const patientsData = [];
      querySnapshot.forEach((doc) => {
        patientsData.push({ id: doc.id, ...doc.data() });
      });
      setPatients(patientsData);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const fetchRendezvous = async (structureId) => {
    try {
      const q = query(collection(db, 'rendezvous'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      const rdvData = [];
      
      for (const doc of querySnapshot.docs) {
        const rdv = doc.data();
        const formattedRdv = {
          id: doc.id,
          ...rdv,
          // Formater la date si elle existe
          date: rdv.date ? formatDateString(new Date(rdv.date)) : '',
          // S'assurer que les noms sont correctement formatés
          medecinNom: rdv.medecinNom || 'Non assigné',
          patientNom: rdv.patientNom || 'Patient inconnu',
          // Ajouter des champs par défaut si manquants
          duree: rdv.duree || '30',
          motif: rdv.motif || 'Consultation',
          statut: rdv.statut || 'en attente',
          // Formater les timestamps
          createdAt: rdv.createdAt ? new Date(rdv.createdAt.toDate()).toLocaleString() : '',
          updatedAt: rdv.updatedAt ? new Date(rdv.updatedAt.toDate()).toLocaleString() : ''
        };
        
        // Si le rendez-vous provient d'une demande rapide, s'assurer que toutes les informations sont présentes
        if (rdv.source === 'quick') {
          formattedRdv.patientEmail = rdv.patientEmail || rdv.email || '';
          formattedRdv.patientTelephone = rdv.patientTelephone || rdv.telephone || '';
          formattedRdv.verificationCode = rdv.verificationCode || '';
        }
        
        rdvData.push(formattedRdv);
      }
      
      setRendezvous(rdvData);
    } catch (error) {
      setMessage(`Erreur lors de la récupération des rendez-vous: ${error.message}`);
    }
  };

  const fetchPendingRequests = async (structureId) => {
    try {
      const medecinRequestsQuery = query(
        collection(db, 'affiliationRequests'),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      );
      const medecinSnapshot = await getDocs(medecinRequestsQuery);
      const medecinRequests = [];
      medecinSnapshot.forEach((doc) => {
        medecinRequests.push({ id: doc.id, ...doc.data() });
      });
      setPendingDoctorRequests(medecinRequests);

      const patientRequestsQuery = query(
        collection(db, 'affiliations'),
        where("structureId", "==", structureId),
        where("statut", "==", "en attente")
      );
      const patientSnapshot = await getDocs(patientRequestsQuery);
      const patientRequests = [];
      patientSnapshot.forEach((doc) => {
        patientRequests.push({ id: doc.id, ...doc.data() });
      });
      setAffiliationRequests(patientRequests);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const fetchQuickRequests = async (structureId) => {
    try {
      const q = query(
        collection(db, 'quickAppointments'),
        where("structureId", "==", structureId),
        where("status", "==", "pending")
      );
      const querySnapshot = await getDocs(q);
      const requests = [];
      querySnapshot.forEach((doc) => {
        requests.push({ id: doc.id, ...doc.data() });
      });
      setDemandesRapides(requests);
      setQuickRequestsCount(requests.length);
    } catch (error) {
      console.error("Erreur lors de la récupération des demandes rapides:", error);
    }
  };

  // Fonctions utilitaires
  const formatDateString = (date) => {
    if (!date) return '';
    const dateObj = date instanceof Date ? date : new Date(date);
    if (isNaN(dateObj.getTime())) return '';
    return `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
  };

  const formatDate = (date) => {
    if (!date) return '';
    const dateObj = date instanceof Date ? date : new Date(date);
    if (isNaN(dateObj.getTime())) return '';
    return `${String(dateObj.getDate()).padStart(2, '0')}/${String(dateObj.getMonth() + 1).padStart(2, '0')}/${dateObj.getFullYear()}`;
  };

  const generateRandomPassword = (length = 10) => {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
    let password = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }
    return password;
  };

  // Fonctions pour le calendrier
  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (year, month) => {
    return new Date(year, month, 1).getDay();
  };

  const getMonthData = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    
    const daysInMonth = getDaysInMonth(year, month);
    const firstDayOfMonth = getFirstDayOfMonth(year, month);
    
    const days = [];
    
    // Jours du mois précédent
    const prevMonthDays = getDaysInMonth(year, month - 1);
    for (let i = firstDayOfMonth - 1; i >= 0; i--) {
      const date = new Date(year, month - 1, prevMonthDays - i);
      const dateString = formatDateString(date);
      days.push({
        date: date,
        isCurrentMonth: false,
        hasEvents: false,
        dateString: dateString
      });
    }
    
    // Jours du mois courant
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(year, month, i);
      const dateString = formatDateString(date);
      
      // Vérifier les rendez-vous pour cette date
      const dayEvents = rendezvous.filter(rdv => rdv.date === dateString);
      const uniqueMedecins = [...new Set(dayEvents.map(rdv => rdv.medecinId))];
      
      days.push({
        date: date,
        isCurrentMonth: true,
        hasEvents: dayEvents.length > 0,
        events: dayEvents,
        medecinCount: uniqueMedecins.length,
        dateString: dateString
      });
    }
    
    // Jours du mois suivant
    const totalDaysToShow = 35; // 5 semaines
    const remainingDays = totalDaysToShow - days.length;
    for (let i = 1; i <= remainingDays; i++) {
      const date = new Date(year, month + 1, i);
      const dateString = formatDateString(date);
      days.push({
        date: date,
        isCurrentMonth: false,
        hasEvents: false,
        dateString: dateString
      });
    }
    
    return days;
  };

  const handlePrevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };

  const handleDateClick = (day) => {
    if (day.hasEvents) {
      setSelectedDate(day);
      setShowDateRdvs(true);
    }
  };

  const getMedecinsByDate = (date) => {
    const dateString = date.dateString || formatDateString(date.date);
    const rdvs = rendezvous.filter(rdv => rdv.date === dateString);
    const uniqueMedecinIds = [...new Set(rdvs.map(rdv => rdv.medecinId))];
    
    return uniqueMedecinIds.map(id => {
      const medecin = medecins.find(m => m.id === id);
      const medecinRdvs = rdvs.filter(rdv => rdv.medecinId === id);
      
      return {
        medecin: medecin,
        rdvCount: medecinRdvs.length
      };
    });
  };

  const getMedecinRdvs = (medecinId, date) => {
    const dateString = date.dateString || formatDateString(date.date);
    
    return rendezvous
      .filter(rdv => rdv.medecinId === medecinId && rdv.date === dateString)
      .sort((a, b) => a.heure.localeCompare(b.heure));
  };

  const handleMedecinClick = (medecinId) => {
    setSelectedMedecinId(medecinId);
    setShowDateRdvs(false);
    setShowMedecinRdvs(true);
  };

  // Fonctions de gestion des événements
  const handleLogout = async () => {
    await signOut(auth);
    navigate('/auth');
  };

  const handleMenuToggle = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setShowMobileMenu(false);
    setShowAddForm(false);
    setShowDetailsView(null);
    setShowSearch(false);
  };

  const handleAddButtonClick = () => {
    setShowAddForm(true);
    resetForms();
  };

  const handleBackToList = () => {
    setShowAddForm(false);
    setShowDetailsView(null);
    resetForms();
  };

  const handleSearchToggle = () => {
    setShowSearch(!showSearch);
    if (!showSearch) {
      setSearchQuery('');
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleUpdate = async () => {
    try {
      const user = auth.currentUser;
      await updateDoc(doc(db, 'structures', user.uid), form);
      setMessage('Informations mises à jour avec succès.');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handlePasswordChange = async () => {
    try {
      const user = auth.currentUser;
      await updatePassword(user, newPassword);
      setMessage('Mot de passe mis à jour avec succès.');
      setNewPassword('');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Gestion des formulaires
  const resetForms = () => {
    resetMedecinForm();
    resetPatientForm();
    resetRdvForm();
    setCurrentMedecin(null);
    setCurrentPatient(null);
    setCurrentRendezvous(null);
  };

  // Médecin
  const resetMedecinForm = () => {
    setMedecinForm({
      nom: '',
      prenom: '',
      specialite: '',
      telephone: '',
      email: '',
      disponibilites: {
        lundi: { actif: false, debut: '08:00', fin: '18:00' },
        mardi: { actif: false, debut: '08:00', fin: '18:00' },
        mercredi: { actif: false, debut: '08:00', fin: '18:00' },
        jeudi: { actif: false, debut: '08:00', fin: '18:00' },
        vendredi: { actif: false, debut: '08:00', fin: '18:00' },
        samedi: { actif: false, debut: '08:00', fin: '18:00' },
        dimanche: { actif: false, debut: '08:00', fin: '18:00' }
      },
      assurances: []
    });
  };

  const handleMedecinChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "assurances") {
      const updatedArray = [...medecinForm.assurances];
      if (checked) {
        updatedArray.push(value);
      } else {
        const index = updatedArray.indexOf(value);
        if (index > -1) {
          updatedArray.splice(index, 1);
        }
      }
      setMedecinForm({ ...medecinForm, [name]: updatedArray });
    } else {
      setMedecinForm({ ...medecinForm, [name]: value });
    }
  };

  const handleDisponibiliteChange = (jour, field, value) => {
    setMedecinForm({
      ...medecinForm,
      disponibilites: {
        ...medecinForm.disponibilites,
        [jour]: {
          ...medecinForm.disponibilites[jour],
          [field]: field === 'actif' ? !medecinForm.disponibilites[jour].actif : value
        }
      }
    });
  };

  const handleAddMedecin = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      let medecinAuthId;
      let generatedPassword = '';
      
      if (!currentMedecin) {
        generatedPassword = generateRandomPassword(12);
        // Utiliser la seconde instance d'authentification
        const userCredential = await createUserWithEmailAndPassword(
          secondaryAuth, 
          medecinForm.email, 
          generatedPassword
        );
        medecinAuthId = userCredential.user.uid;
        // Déconnecter immédiatement l'utilisateur de la seconde instance
        await signOut(secondaryAuth);
      }
      
      const disponibilitesAEnregistrer = [];
      Object.entries(medecinForm.disponibilites).forEach(([jour, valeur]) => {
        if (valeur.actif) {
          disponibilitesAEnregistrer.push({
            jour: jour.charAt(0).toUpperCase() + jour.slice(1),
            heureDebut: valeur.debut,
            heureFin: valeur.fin
          });
        }
      });
      
      const medecinData = {
        ...medecinForm,
        disponibilites: disponibilitesAEnregistrer,
        structureId: user.uid,
      };
      
      if (currentMedecin) {
        await updateDoc(doc(db, 'medecins', currentMedecin.id), {
          ...medecinData,
          updatedAt: new Date()
        });
        setMessage('Médecin mis à jour avec succès.');
      } else {
        await setDoc(doc(db, 'medecins', medecinAuthId), {
          ...medecinData,
          createdAt: new Date()
        });
        setMessage('Médecin ajouté avec succès.');
      }
      
      resetMedecinForm();
      setShowAddForm(false);
      fetchMedecins(user.uid);
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handleEditMedecin = (medecin) => {
    setCurrentMedecin(medecin);
    
    let disponibilitesFormattees = {
      lundi: { actif: false, debut: '08:00', fin: '18:00' },
      mardi: { actif: false, debut: '08:00', fin: '18:00' },
      mercredi: { actif: false, debut: '08:00', fin: '18:00' },
      jeudi: { actif: false, debut: '08:00', fin: '18:00' },
      vendredi: { actif: false, debut: '08:00', fin: '18:00' },
      samedi: { actif: false, debut: '08:00', fin: '18:00' },
      dimanche: { actif: false, debut: '08:00', fin: '18:00' }
    };
    
    if (medecin.disponibilites && Array.isArray(medecin.disponibilites)) {
      medecin.disponibilites.forEach(dispo => {
        const jour = dispo.jour.toLowerCase();
        if (disponibilitesFormattees[jour]) {
          disponibilitesFormattees[jour] = {
            actif: true,
            debut: dispo.heureDebut || '08:00',
            fin: dispo.heureFin || '18:00'
          };
        }
      });
    } else if (medecin.disponibilites && typeof medecin.disponibilites === 'object') {
      disponibilitesFormattees = medecin.disponibilites;
    }
    
    setMedecinForm({
      nom: medecin.nom || '',
      prenom: medecin.prenom || '',
      specialite: medecin.specialite || '',
      telephone: medecin.telephone || '',
      email: medecin.email || '',
      disponibilites: disponibilitesFormattees,
      assurances: medecin.assurances || []
    });
    
    setShowAddForm(true);
  };

  const handleDeleteMedecin = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce médecin ?')) {
      try {
        await deleteDoc(doc(db, 'medecins', id));
        setMessage('Médecin supprimé avec succès.');
        const user = auth.currentUser;
        fetchMedecins(user.uid);
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur: ${error.message}`);
      }
    }
  };

  const handleViewMedecin = (medecin) => {
    setShowDetailsView({ type: 'medecin', data: medecin });
  };

  // Patient
  const resetPatientForm = () => {
    setPatientForm({
      nom: '',
      prenom: '',
      dateNaissance: '',
      email: '',
      telephone: '',
      assurances: [],
      diagnostics: '' // Réinitialisation du champ diagnostics
    });
  };

  const handlePatientChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "assurances") {
      const updatedArray = [...patientForm.assurances];
      if (checked) {
        updatedArray.push(value);
      } else {
        const index = updatedArray.indexOf(value);
        if (index > -1) {
          updatedArray.splice(index, 1);
        }
      }
      setPatientForm({ ...patientForm, [name]: updatedArray });
    } else {
      setPatientForm({ ...patientForm, [name]: value });
    }
  };

  const handleAddPatient = async (e) => {
    e.preventDefault();
    // Numéro de téléphone obligatoire
    if (!patientForm.telephone) {
      setMessage('Le numéro de téléphone est obligatoire.');
      return;
    }
    try {
      const user = auth.currentUser;
      let patientAuthId;
      let generatedPassword = '';
      const shouldCreateAuthUser = patientForm.email && patientForm.email.trim() !== '';

      if (!currentPatient && shouldCreateAuthUser) {
        generatedPassword = generateRandomPassword(12);
        const userCredential = await createUserWithEmailAndPassword(
          secondaryAuth,
          patientForm.email,
          generatedPassword
        );
        patientAuthId = userCredential.user.uid;
        await signOut(secondaryAuth);
      }

      const patientData = {
        ...patientForm,
        structureId: user.uid,
      };

      if (currentPatient) {
        await updateDoc(doc(db, 'patients', currentPatient.id), {
          ...patientData,
          updatedAt: new Date(),
        });
        setMessage('Patient mis à jour avec succès.');
      } else {
        if (patientAuthId) {
          await setDoc(doc(db, 'patients', patientAuthId), {
            ...patientData,
            createdAt: new Date(),
          });
        } else {
          await addDoc(collection(db, 'patients'), {
            ...patientData,
            createdAt: new Date(),
          });
        }
        setMessage('Patient ajouté avec succès.');
      }

      resetPatientForm();
      setShowAddForm(false);
      fetchPatients(user.uid);
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handleEditPatient = (patient) => {
    setCurrentPatient(patient);
    setPatientForm({
      nom: patient.nom || '',
      prenom: patient.prenom || '',
      dateNaissance: patient.dateNaissance || '',
      email: patient.email || '',
      telephone: patient.telephone || '',
      assurances: patient.assurances || [],
      diagnostics: patient.diagnostics || '' // Ajout du champ diagnostics
    });
    setShowAddForm(true);
  };

  const handleDeletePatient = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce patient ?')) {
      try {
        await deleteDoc(doc(db, 'patients', id));
        setMessage('Patient supprimé avec succès.');
        const user = auth.currentUser;
        fetchPatients(user.uid);
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur: ${error.message}`);
      }
    }
  };

  const handleViewPatient = (patient) => {
    setShowDetailsView({ type: 'patient', data: patient });
  };

  // Rendez-vous
  const resetRdvForm = () => {
    setRdvForm({
      medecinId: '',
      patientId: '',
      date: new Date().toISOString().split('T')[0],
      heure: '08:00',
      motif: '',
      statut: 'confirmé'
    });
  };

  const handleRdvChange = (e) => {
    const { name, value } = e.target;
    setRdvForm({ ...rdvForm, [name]: value });
  };

  // Déclarer la fonction comme une nouvelle constante
  const verifierDisponibilite = (medecinId, date, heure, rdvIdAExclure = null) => {
    const medecin = medecins.find(m => m.id === medecinId);
    if (!medecin) return false;
    
    const jourDate = new Date(date);
    const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    const jourSemaine = joursMap[jourDate.getDay()];
    
    let disponibiliteJour = null;
    if (Array.isArray(medecin.disponibilites)) {
      disponibiliteJour = medecin.disponibilites.find(d => 
        d.jour.toLowerCase() === jourSemaine.toLowerCase()
      );
    } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
      disponibiliteJour = medecin.disponibilites[jourSemaine].actif ? {
        heureDebut: medecin.disponibilites[jourSemaine].debut,
        heureFin: medecin.disponibilites[jourSemaine].fin
      } : null;
    }
    
    if (!disponibiliteJour) return false;
    
    const heureDebut = disponibiliteJour.heureDebut || disponibiliteJour.debut;
    const heureFin = disponibiliteJour.heureFin || disponibiliteJour.fin;
    
    if (heure < heureDebut || heure > heureFin) return false;
    
    const rdvDuJour = rendezvous.filter(rdv => 
      rdv.medecinId === medecinId && 
      rdv.date === date && 
      rdv.statut !== 'annulé' &&
      rdv.id !== rdvIdAExclure
    );
    
    const rdvAuCreneau = rdvDuJour.filter(rdv => rdv.heure === heure);
    const MAX_RDV_SIMULTANES = 3;
    
    if (rdvAuCreneau.length >= MAX_RDV_SIMULTANES) {
      return false;
    }
    
    return true;
  };


  
  const getCreneauxAvecStatut = () => {
    if (!rdvForm.medecinId || !rdvForm.date) return [];
    
    const medecin = medecins.find(m => m.id === rdvForm.medecinId);
    if (!medecin) return [];
    
    const jourDate = new Date(rdvForm.date);
    const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    const jourSemaine = joursMap[jourDate.getDay()];
    
    let heureDebut = '08:00';
    let heureFin = '18:00';
    let disponibiliteJour = null;
    
    if (Array.isArray(medecin.disponibilites)) {
      disponibiliteJour = medecin.disponibilites.find(d => 
        d.jour.toLowerCase() === jourSemaine.toLowerCase()
      );
      
      if (disponibiliteJour) {
        heureDebut = disponibiliteJour.heureDebut;
        heureFin = disponibiliteJour.heureFin;
      } else {
        return [];
      }
    } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
      if (!medecin.disponibilites[jourSemaine].actif) {
        return [];
      }
      heureDebut = medecin.disponibilites[jourSemaine].debut;
      heureFin = medecin.disponibilites[jourSemaine].fin;
    } else {
      return [];
    }
    
    const rdvDuJour = rendezvous.filter(rdv => 
      rdv.medecinId === rdvForm.medecinId && 
      rdv.date === rdvForm.date && 
      rdv.statut !== 'annulé' &&
      rdv.id !== currentRendezvous?.id
    );
    
    const tousLesCreneaux = [];
    let heure = heureDebut;
    const MAX_RDV_SIMULTANES = 3;
    
    while (heure < heureFin) {
      const [h, m] = heure.split(':').map(Number);
      const nextHeure = new Date();
      nextHeure.setHours(h, m + 15, 0, 0);
      const heureFinStr = `${nextHeure.getHours().toString().padStart(2, '0')}:${nextHeure.getMinutes().toString().padStart(2, '0')}`;
      
      if (heureFinStr <= heureFin) {
        const rdvAuCreneau = rdvDuJour.filter(rdv => rdv.heure === heure);
        const nombreRdvAuCreneau = rdvAuCreneau.length;
        
        let statut = 'disponible';
        if (nombreRdvAuCreneau >= MAX_RDV_SIMULTANES) {
          statut = 'complet';
        } else if (nombreRdvAuCreneau > 0) {
          statut = 'partiel';
        }
        
        tousLesCreneaux.push({
          heure: heure,
          statut: statut,
          nombreRdv: nombreRdvAuCreneau,
          estDisponible: statut !== 'complet'
        });
      }
      
      heure = `${nextHeure.getHours().toString().padStart(2, '0')}:${nextHeure.getMinutes().toString().padStart(2, '0')}`;
    }
    
    return tousLesCreneaux;
  };

  const handleAddRendezvous = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      
      const estDisponible = verifierDisponibilite(
        rdvForm.medecinId, 
        rdvForm.date, 
        rdvForm.heure,
        currentRendezvous?.id
      );
      
      if (!estDisponible) {
        setMessage("Erreur: Le médecin n'est pas disponible à cette heure ou il y a un conflit d'horaire.");
        return;
      }
      
      const dateObj = new Date(rdvForm.date);
      const normalizedDate = formatDateString(dateObj);
      
      const rdvData = {
        ...rdvForm,
        date: normalizedDate,
        structureId: user.uid,
      };
      
      const medecin = medecins.find(m => m.id === rdvForm.medecinId);
      const patient = patients.find(p => p.id === rdvForm.patientId);
      
      if (medecin) {
        rdvData.medecinNom = `${medecin.prenom} ${medecin.nom}`;
        rdvData.medecinSpecialite = medecin.specialite;
      }
      
      if (patient) {
        rdvData.patientNom = `${patient.prenom} ${patient.nom}`;
      }
      
      if (currentRendezvous) {
        await updateDoc(doc(db, 'rendezvous', currentRendezvous.id), {
          ...rdvData,
          updatedAt: new Date()
        });
        setMessage('Rendez-vous mis à jour avec succès.');
      } else {
        await addDoc(collection(db, 'rendezvous'), {
          ...rdvData,
          createdAt: new Date()
        });
        setMessage('Rendez-vous ajouté avec succès.');
      }
      
      resetRdvForm();
      setShowAddForm(false);
      fetchRendezvous(user.uid);
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    }
  };

  const handleEditRendezvous = (rdv) => {
    setCurrentRendezvous(rdv);
    setRdvForm({
      medecinId: rdv.medecinId || '',
      patientId: rdv.patientId || '',
      date: rdv.date || new Date().toISOString().split('T')[0],
      heure: rdv.heure || '08:00',
      motif: rdv.motif || '',
      statut: rdv.statut || 'confirmé'
    });
    setShowAddForm(true);
  };

  const handleDeleteRendezvous = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce rendez-vous ?')) {
      try {
        await deleteDoc(doc(db, 'rendezvous', id));
        setMessage('Rendez-vous supprimé avec succès.');
        const user = auth.currentUser;
        fetchRendezvous(user.uid);
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(`Erreur: ${error.message}`);
      }
    }
  };

  const handleViewRendezvous = (rdv) => {
    setShowDetailsView({ type: 'rendezvous', data: rdv });
  };

  // Gestion des demandes rapides
  const handleAccepterDemandeRapide = async (demande) => {
    try {
      setLoading(true);
      
      // Chercher si le patient existe déjà
      const patientQuery = query(
        collection(db, 'patients'),
        where("structureId", "==", demande.structureId),
        where("telephone", "==", demande.telephone)
      );
      const patientSnapshot = await getDocs(patientQuery);
      
      let patientId = null;
      
      // Si le patient n'existe pas encore, le créer
      if (patientSnapshot.empty) {
        const patientData = {
          nom: demande.nom,
          prenom: demande.prenom,
          dateNaissance: demande.dateNaissance || '',
          email: demande.email || '',
          telephone: demande.telephone,
          structureId: demande.structureId,
          createdAt: new Date(),
          assurances: [],
          diagnostics: '' // Ajout du champ diagnostics
        };
        
        const docRef = await addDoc(collection(db, 'patients'), patientData);
        patientId = docRef.id;
      } else {
        patientId = patientSnapshot.docs[0].id;
      }
      
      // Mettre à jour le rendez-vous
      await updateDoc(doc(db, 'rendezvous', demande.id), {
        statut: 'confirmé',
        patientId: patientId
      });
      
      // Rafraîchir les données
      const user = auth.currentUser;
      fetchDemandesRapides();
      fetchRendezvous(user.uid);
      
      setMessage("La demande a été acceptée avec succès !");
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleRefuserDemandeRapide = async (demandeId) => {
    try {
      setLoading(true);
      
      // Mettre à jour le statut du rendez-vous à "refusé"
      await updateDoc(doc(db, 'rendezvous', demandeId), {
        statut: 'refusé'
      });
      
      // Rafraîchir les données
      fetchDemandesRapides();
      
      setMessage("La demande rapide a été refusée.");
    } catch (error) {
      setMessage(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Filtrage des données
  const filteredMedecins = searchQuery 
    ? medecins.filter(m => 
        `${m.nom} ${m.prenom}`.toLowerCase().includes(searchQuery.toLowerCase()) ||
        m.specialite.toLowerCase().includes(searchQuery.toLowerCase()) ||
        m.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
        m.telephone.includes(searchQuery)
      )
    : medecins;

  const filteredPatients = searchQuery 
    ? patients.filter(p => 
        `${p.nom} ${p.prenom}`.toLowerCase().includes(searchQuery.toLowerCase()) ||
        p.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
        p.telephone.includes(searchQuery)
      )
    : patients;

  const filteredRendezvous = searchQuery 
    ? rendezvous.filter(r => 
        r.patientNom?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        r.medecinNom?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        r.date?.includes(searchQuery) ||
        r.heure?.includes(searchQuery)
      )
    : rendezvous;

  // Regrouper les rendez-vous par date pour l'affichage mobile
  const rdvGroupedByDate = () => {
    const grouped = {};
    
    filteredRendezvous.forEach(rdv => {
      if (!grouped[rdv.date]) {
        grouped[rdv.date] = [];
      }
      grouped[rdv.date].push(rdv);
    });
    
    // Trier les dates par ordre chronologique
    return Object.keys(grouped)
      .sort()
      .map(date => ({
        date: date,
        formattedDate: formatDate(date),
        rdvs: grouped[date].sort((a, b) => a.heure.localeCompare(b.heure))
      }));
  };

  
  // Afficher le loader pendant le chargement
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="mobile-dashboard">
      {/* En-tête fixe */}
      <header className="mobile-header">
        <button className="menu-toggle" onClick={handleMenuToggle}>
          <FontAwesomeIcon icon={faBars} />
        </button>
        <h1 className="header-title">
          {activeTab === 'info' && 'Informations'}
          {activeTab === 'affiliations' && 'Affiliations'}
          {activeTab === 'medecins' && 'Médecins'}
          {activeTab === 'patients' && 'Patients'}
          {activeTab === 'rendezvous' && 'Rendez-vous'}
          {activeTab === 'archives' && 'Archives'}
          {activeTab === 'password' && 'Mot de passe'}
          {activeTab === 'demandesRapides' && 'Demandes rapides'}
        </h1>
        <div className="header-actions">
          {(activeTab === 'medecins' || activeTab === 'patients' || activeTab === 'rendezvous') && !showAddForm && !showDetailsView && (
            <>
              <button className="action-btn search-btn" onClick={handleSearchToggle}>
                <FontAwesomeIcon icon={faSearch} />
              </button>
              <button className="action-btn add-btn" onClick={handleAddButtonClick}>
                <FontAwesomeIcon icon={faPlus} />
              </button>
            </>
          )}
          {(showAddForm || showDetailsView || showDateRdvs || showMedecinRdvs) && (
            <button className="action-btn back-btn" onClick={
              showMedecinRdvs ? () => { setShowMedecinRdvs(false); setShowDateRdvs(true); } :
              showDateRdvs ? () => setShowDateRdvs(false) :
              handleBackToList
            }>
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
          )}
        </div>
      </header>

      {/* Menu latéral */}
      <div className={`mobile-sidebar ${showMobileMenu ? 'active' : ''}`}>
        <div className="sidebar-header">
          <h2>{structureData.nom}</h2>
          <button className="close-menu" onClick={handleMenuToggle}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <ul className="sidebar-menu">
          <li className={activeTab === 'info' ? 'active' : ''} onClick={() => handleTabChange('info')}>
            <FontAwesomeIcon icon={faHome} />
            <span>Informations</span>
          </li>
          <li className={activeTab === 'affiliations' ? 'active' : ''} onClick={() => handleTabChange('affiliations')}>
            <FontAwesomeIcon icon={faLink} />
            <span>Affiliations</span>
            {(pendingDoctorRequests?.length || 0) + (affiliationRequests?.filter(req => req.statut === 'en attente')?.length || 0) > 0 && (
              <span className="badge bg-danger">
                {(pendingDoctorRequests?.length || 0) + (affiliationRequests?.filter(req => req.statut === 'en attente')?.length || 0)}
              </span>
            )}
          </li>
          <li className={activeTab === 'medecins' ? 'active' : ''} onClick={() => handleTabChange('medecins')}>
            <FontAwesomeIcon icon={faUserMd} />
            <span>Médecins</span>
            <span className="badge bg-info">{medecins.length}</span>
          </li>
          <li className={activeTab === 'patients' ? 'active' : ''} onClick={() => handleTabChange('patients')}>
            <FontAwesomeIcon icon={faUser} />
            <span>Patients</span>
            <span className="badge bg-info">{patients.length}</span>
          </li>
          <li className={activeTab === 'rendezvous' ? 'active' : ''} onClick={() => handleTabChange('rendezvous')}>
            <FontAwesomeIcon icon={faCalendarAlt} />
            <span>Rendez-vous</span>
            <div className="badge-container">
              <span className="badge bg-info">{rendezvous.length}</span>
              {quickRequestsCount > 0 && (
                <span className="badge bg-danger quick-badge">{quickRequestsCount}</span>
              )}
            </div>
          </li>
          <li className={activeTab === 'archives' ? 'active' : ''} onClick={() => handleTabChange('archives')}>
      <FontAwesomeIcon icon={faArchive} />
      <span>Archives</span>
      <span className="badge bg-info">{archives.length}</span>
    </li>
          
          <li className={activeTab === 'password' ? 'active' : ''} onClick={() => handleTabChange('password')}>
            <FontAwesomeIcon icon={faKey} />
            <span>Mot de passe</span>
          </li>
          <li className={activeTab === 'demandesRapides' ? 'active' : ''} onClick={() => handleTabChange('demandesRapides')}>
            <FontAwesomeIcon icon={faBolt} />
            <span>Demandes rapides</span>
            <span className="badge bg-warning">{demandesRapides.length}</span>
          </li>
          <li onClick={handleLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} />
            <span>Déconnexion</span>
          </li>
        </ul>
      </div>

      {/* Barre de recherche */}
      {showSearch && (
        <div className="mobile-search">
          <input
            type="text"
            placeholder="Rechercher..."
            value={searchQuery}
            onChange={handleSearchChange}
            autoFocus
          />
          <button onClick={handleSearchToggle}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      )}

      {/* Contenu principal */}
      <main className="mobile-content">
        {/* Messages de notification */}
        {message && (
          <div className={`alert alert-dismissible fade show ${message.includes('Erreur') ? 'alert-danger' : 'alert-success'}`} role="alert">
            {message}
            <button type="button" className="btn-close" onClick={() => setMessage('')}></button>
          </div>
        )}

        {/* Onglet Informations */}
        {activeTab === 'info' && (
          <div className="info-section">
            <div className="card mb-3">
              <div className="card-body">
                {Object.keys(form).map((key) => (
                  key !== 'createdAt' && key !== 'updatedAt' ? (
                    <div className="mb-3" key={key}>
                      <label className="form-label">{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                      <input
                        name={key}
                        value={form[key] || ''}
                        onChange={handleChange}
                        className="form-control"
                        placeholder={key}
                      />
                    </div>
                  ) : null
                ))}
                <button onClick={handleUpdate} className="btn btn-primary w-100">
                  <FontAwesomeIcon icon={faCheck} className="me-2" />
                  Mettre à jour
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Onglet Médecins */}
        {activeTab === 'medecins' && !showAddForm && !showDetailsView && (
          <div className="medecins-list">
            {filteredMedecins.length > 0 ? (
              filteredMedecins.map(medecin => (
                <div className="card mb-3" key={medecin.id} onClick={() => handleViewMedecin(medecin)}>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start">
                      <h5 className="card-title">Dr. {medecin.prenom} {medecin.nom}</h5>
                      <span className="badge bg-info">{medecin.specialite}</span>
                    </div>
                    <p className="card-text">
                      <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                      {medecin.telephone}
                    </p>
                    <p className="card-text">
                      <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                      {medecin.email}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-5">
                <p className="text-muted">Aucun médecin trouvé</p>
                <button className="btn btn-primary" onClick={handleAddButtonClick}>
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  Ajouter un médecin
                </button>
              </div>
            )}
          </div>
        )}

        {/* Détails d'un médecin */}
        {showDetailsView && showDetailsView.type === 'medecin' && (
          <div className="medecin-details">
            <div className="card mb-3">
              <div className="card-body">
                <h5 className="card-title">Dr. {showDetailsView.data.prenom} {showDetailsView.data.nom}</h5>
                <p className="text-muted">{showDetailsView.data.specialite}</p>
                
                <div className="info-item">
                  <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                  {showDetailsView.data.telephone}
                </div>
                
                <div className="info-item">
                  <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                  {showDetailsView.data.email}
                </div>
                
                <div className="mt-3">
                  <h6>Disponibilités:</h6>
                  <div className="disponibilites-container">
                    {Array.isArray(showDetailsView.data.disponibilites) ? (
                      showDetailsView.data.disponibilites.map((dispo, index) => (
                        <span key={index} className="badge bg-light text-dark me-1 mb-1">
                          {dispo.jour}: {dispo.heureDebut}-{dispo.heureFin}
                        </span>
                      ))
                    ) : (
                      Object.entries(showDetailsView.data.disponibilites || {}).map(([jour, dispo]) => (
                        dispo.actif && (
                          <span key={jour} className="badge bg-light text-dark me-1 mb-1">
                            {jour.charAt(0).toUpperCase() + jour.slice(1)}: {dispo.debut}-{dispo.fin}
                          </span>
                        )
                      ))
                    )}
                  </div>
                </div>
                
                {showDetailsView.data.assurances && showDetailsView.data.assurances.length > 0 && (
                  <div className="mt-3">
                    <h6>Assurances acceptées:</h6>
                    <div>
                      {showDetailsView.data.assurances.map((assurance, index) => (
                        <span key={index} className="badge bg-light text-dark me-1 mb-1">
                          {assurance}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                
                <div className="d-flex justify-content-between mt-4">
                  <button 
                    className="btn btn-outline-primary" 
                    onClick={() => handleEditMedecin(showDetailsView.data)}
                  >
                    <FontAwesomeIcon icon={faEdit} className="me-2" />
                    Modifier
                  </button>
                  <button 
                    className="btn btn-outline-danger" 
                    onClick={() => {
                      handleDeleteMedecin(showDetailsView.data.id);
                      setShowDetailsView(null);
                    }}
                  >
                    <FontAwesomeIcon icon={faTrash} className="me-2" />
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Formulaire d'ajout/modification de médecin */}
        {activeTab === 'medecins' && showAddForm && (
          <div className="medecin-form">
            <h5 className="form-title">{currentMedecin ? 'Modifier le médecin' : 'Ajouter un médecin'}</h5>
            <form onSubmit={handleAddMedecin}>
              <div className="mb-3">
                <label className="form-label">Nom</label>
                <input
                  type="text"
                  name="nom"
                  className="form-control"
                  value={medecinForm.nom}
                  onChange={handleMedecinChange}
                  
                />
              </div>
              
              <div className="mb-3">
                <label className="form-label">Prénom</label>
                <input
                  type="text"
                  name="prenom"
                  className="form-control"
                  value={medecinForm.prenom}
                  onChange={handleMedecinChange}
                  
                />
              </div>
              
              <div className="mb-3">
                <label className="form-label">Spécialité</label>
                <select
                  name="specialite"
                  className="form-select"
                  value={medecinForm.specialite}
                  onChange={handleMedecinChange}
                  
                >
                  <option value="">Sélectionner une spécialité</option>
                  {specialites.map((spec) => (
                    <option key={spec} value={spec}>{spec}</option>
                  ))}
                </select>
              </div>
              
              <div className="mb-3">
                <label className="form-label">Téléphone</label>
                <input
                  type="tel"
                  name="telephone"
                  className="form-control"
                  value={medecinForm.telephone}
                  onChange={handleMedecinChange}
                  required
                />
              </div>
              
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={medecinForm.email}
                  onChange={handleMedecinChange}
                  
                />
              </div>
              
              <div className="mb-3">
                <label className="form-label">Disponibilités</label>
                <div className="disponibilites-mobile">
                  {joursSemaine.map((jour) => (
                    <div key={jour} className="jour-disponibilite">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`disponible-${jour}`}
                          checked={medecinForm.disponibilites[jour].actif}
                          onChange={() => handleDisponibiliteChange(jour, 'actif')}
                        />
                        <label className="form-check-label" htmlFor={`disponible-${jour}`}>
                          {jour.charAt(0).toUpperCase() + jour.slice(1)}
                        </label>
                      </div>
                      
                      {medecinForm.disponibilites[jour].actif && (
                        <div className="horaires-container">
                          <div className="horaire-item">
                            <label>Début</label>
                            <input
                              type="time"
                              className="form-control"
                              value={medecinForm.disponibilites[jour].debut}
                              onChange={(e) => handleDisponibiliteChange(jour, 'debut', e.target.value)}
                            />
                          </div>
                          <div className="horaire-item">
                            <label>Fin</label>
                            <input
                              type="time"
                              className="form-control"
                              value={medecinForm.disponibilites[jour].fin}
                              onChange={(e) => handleDisponibiliteChange(jour, 'fin', e.target.value)}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="mb-3">
                <label className="form-label">Assurances acceptées</label>
                <div className="assurances-container">
                  {assurancesList.map((assurance) => (
                    <div className="form-check" key={assurance}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`assurance-medecin-${assurance}`}
                        name="assurances"
                        value={assurance}
                        checked={medecinForm.assurances.includes(assurance)}
                        onChange={handleMedecinChange}
                      />
                      <label className="form-check-label" htmlFor={`assurance-medecin-${assurance}`}>
                        {assurance}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="form-actions">
              <button type="submit" className="btn btn-primary w-100">
                  <FontAwesomeIcon icon={faCheck} className="me-2" />
                  {currentMedecin ? 'Mettre à jour' : 'Ajouter'}
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Onglet Patients */}
        {activeTab === 'patients' && !showAddForm && !showDetailsView && (
          <div className="patients-list">
            {filteredPatients.length > 0 ? (
              filteredPatients.map(patient => (
                <div className="card mb-3" key={patient.id} onClick={() => handleViewPatient(patient)}>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start">
                      <h5 className="card-title">{patient.prenom} {patient.nom}</h5>
                      <span className="badge bg-secondary">
                        {new Date().getFullYear() - new Date(patient.dateNaissance).getFullYear()} ans
                      </span>
                    </div>
                    <p className="card-text">
                      <small className="text-muted">Né(e) le {formatDate(patient.dateNaissance)}</small>
                    </p>
                    <p className="card-text">
                      <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                      {patient.telephone}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-5">
                <p className="text-muted">Aucun patient trouvé</p>
                <button className="btn btn-primary" onClick={handleAddButtonClick}>
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  Ajouter un patient
                </button>
              </div>
            )}
          </div>
        )}

        {/* Détails d'un patient */}
        {showDetailsView && showDetailsView.type === 'patient' && (
          <div className="patient-details">
            <div className="card mb-3">
              <div className="card-body">
                <h5 className="card-title">{showDetailsView.data.prenom} {showDetailsView.data.nom}</h5>
                <p className="text-muted">
                  Né(e) le {formatDate(showDetailsView.data.dateNaissance)} 
                  ({new Date().getFullYear() - new Date(showDetailsView.data.dateNaissance).getFullYear()} ans)
                </p>
                
                <div className="info-item">
                  <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                  {showDetailsView.data.telephone}
                </div>
                
                <div className="info-item">
                  <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                  {showDetailsView.data.email}
                </div>
                
                {showDetailsView.data.assurances && showDetailsView.data.assurances.length > 0 && (
                  <div className="mt-3">
                    <h6>Assurances:</h6>
                    <div>
                      {showDetailsView.data.assurances.map((assurance, index) => (
                        <span key={index} className="badge bg-light text-dark me-1 mb-1">
                          {assurance}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                
                {showDetailsView.data.diagnostics && (
                  <div className="mt-3">
                    <h6>Diagnostics:</h6>
                    <p className="text-muted">{showDetailsView.data.diagnostics}</p>
                  </div>
                )}
                
                <div className="d-flex justify-content-between mt-4">
                  <button 
                    className="btn btn-outline-primary" 
                    onClick={() => handleEditPatient(showDetailsView.data)}
                  >
                    <FontAwesomeIcon icon={faEdit} className="me-2" />
                    Modifier
                  </button>
                  <button 
                    className="btn btn-outline-danger" 
                    onClick={() => {
                      handleDeletePatient(showDetailsView.data.id);
                      setShowDetailsView(null);
                    }}
                  >
                    <FontAwesomeIcon icon={faTrash} className="me-2" />
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Formulaire d'ajout/modification de patient */}
        {activeTab === 'patients' && showAddForm && (
          <div className="patient-form">
            <h5 className="form-title">{currentPatient ? 'Modifier le patient' : 'Ajouter un patient'}</h5>
            <form onSubmit={handleAddPatient}>
              <div className="mb-3">
                <label className="form-label">Nom</label>
                <input
                  type="text"
                  name="nom"
                  className="form-control"
                  value={patientForm.nom}
                  onChange={handlePatientChange}
                  
                />
              </div>
              
              <div className="mb-3">
                <label className="form-label">Prénom</label>
                <input
                  type="text"
                  name="prenom"
                  className="form-control"
                  value={patientForm.prenom}
                  onChange={handlePatientChange}
                  
                />
              </div>
              
              <div className="mb-3">
                <label className="form-label">Date de naissance</label>
                <input
                  type="date"
                  name="dateNaissance"
                  className="form-control"
                  value={patientForm.dateNaissance}
                  onChange={handlePatientChange}
                  
                />
              </div>
              
              <div className="mb-3">
                <label className="form-label">Téléphone</label>
                <input
                  type="tel"
                  name="telephone"
                  className="form-control"
                  value={patientForm.telephone}
                  onChange={handlePatientChange}
                  required
                />
              </div>
              
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={patientForm.email}
                  onChange={handlePatientChange}
                  
                />
              </div>
              
              <div className="mb-3">
                <label className="form-label">Assurances</label>
                <div className="assurances-container">
                  {assurancesList.map((assurance) => (
                    <div className="form-check" key={assurance}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`assurance-patient-${assurance}`}
                        name="assurances"
                        value={assurance}
                        checked={patientForm.assurances.includes(assurance)}
                        onChange={handlePatientChange}
                      />
                      <label className="form-check-label" htmlFor={`assurance-patient-${assurance}`}>
                        {assurance}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="mb-3">
                <label className="form-label">Diagnostics</label>
                <textarea
                  name="diagnostics"
                  className="form-control"
                  value={patientForm.diagnostics}
                  onChange={handlePatientChange}
                  rows="3"
                  placeholder="Entrez les diagnostics du patient"
                />
              </div>
              
              <div className="text-end mt-3">
                <button type="button" className="btn btn-secondary me-2" onClick={() => {
                  resetPatientForm();
                  setShowPatientForm(false);
                }}>
                  <FontAwesomeIcon icon={faTimes} className="me-2" />
                  Annuler
                </button>
                <button type="submit" className="btn btn-primary">
                  <FontAwesomeIcon icon={faCheck} className="me-2" />
                  {currentPatient ? 'Mettre à jour' : 'Ajouter'}
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Onglet Rendez-vous */}
        {activeTab === 'rendezvous' && !showAddForm && !showDetailsView && !showDateRdvs && !showMedecinRdvs && (
          <div className="rendezvous-section">
            {/* Mini-calendrier */}
            <div className="card mb-3">
              <div className="card-body p-2">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <button className="btn btn-sm btn-outline-secondary" onClick={handlePrevMonth}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </button>
                  <h6 className="mb-0">
                    {currentMonth.toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}
                  </h6>
                  <button className="btn btn-sm btn-outline-secondary" onClick={handleNextMonth}>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                </div>
                
                <div className="mobile-calendar">
                  <div className="calendar-header">
                    {['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, index) => (
                      <div key={index} className="calendar-cell header">
                        {day}
                      </div>
                    ))}
                  </div>
                  <div className="calendar-body">
                    {getMonthData().map((day, index) => (
                      <div 
                        key={index} 
                        className={`calendar-cell ${!day.isCurrentMonth ? 'other-month' : ''} ${day.hasEvents ? 'has-events' : ''}`}
                        onClick={() => handleDateClick(day)}
                      >
                        <div className="date-number">{day.date.getDate()}</div>
                        {day.hasEvents && (
                          <div className="event-dot"></div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            
            {/* Liste des rendez-vous */}
            <div className="rdv-list-mobile">
              <h6 className="list-title">Prochains rendez-vous</h6>
              
              {rdvGroupedByDate().length > 0 ? (
                rdvGroupedByDate().map(dateGroup => (
                  <div className="date-group" key={dateGroup.date}>
                    <div className="date-header">
                      <h6>{dateGroup.formattedDate}</h6>
                      <span className="badge bg-primary">{dateGroup.rdvs.length}</span>
                    </div>
                    
                    {dateGroup.rdvs.map(rdv => (
                      <div 
                        className={`rdv-item status-${rdv.statut}`} 
                        key={rdv.id}
                        onClick={() => handleViewRendezvous(rdv)}
                      >
                        <div className="rdv-time">
                          <FontAwesomeIcon icon={faClock} className="me-1" />
                          {rdv.heure}
                        </div>
                        <div className="rdv-info">
                          <div className="rdv-patient">{rdv.patientNom}</div>
                          <div className="rdv-doctor">Dr. {rdv.medecinNom}</div>
                        </div>
                        <div className="rdv-status">
                          <span className={`status-badge status-${rdv.statut}`}>
                            {rdv.statut}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <div className="text-center py-4">
                  <p className="text-muted">Aucun rendez-vous trouvé</p>
                  <button className="btn btn-primary" onClick={handleAddButtonClick}>
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Ajouter un rendez-vous
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Vue des rendez-vous par date */}
        {showDateRdvs && selectedDate && (
          <div className="date-rdvs">
            <h5 className="mb-3">Rendez-vous du {formatDate(selectedDate.date)}</h5>
            
            {getMedecinsByDate(selectedDate).length > 0 ? (
              <div className="list-group">
                {getMedecinsByDate(selectedDate).map((item, index) => (
                  <button 
                    key={index} 
                    className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                    onClick={() => handleMedecinClick(item.medecin.id)}
                  >
                    <div>
                      <h6 className="mb-0">Dr. {item.medecin.prenom} {item.medecin.nom}</h6>
                      <small className="text-muted">{item.medecin.specialite}</small>
                    </div>
                    <span className="badge bg-primary rounded-pill">{item.rdvCount} RDV</span>
                  </button>
                ))}
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">Aucun rendez-vous pour cette date</p>
              </div>
            )}
          </div>
        )}

        {/* Vue des rendez-vous d'un médecin à une date donnée */}
        {showMedecinRdvs && selectedMedecinId && selectedDate && (
          <div className="medecin-rdvs">
            <h5 className="mb-2">
              Dr. {medecins.find(m => m.id === selectedMedecinId)?.prenom} {medecins.find(m => m.id === selectedMedecinId)?.nom}
            </h5>
            <p className="text-muted mb-3">{formatDate(selectedDate.date)}</p>
            
            {getMedecinRdvs(selectedMedecinId, selectedDate).length > 0 ? (
              <div className="rdv-list">
                {getMedecinRdvs(selectedMedecinId, selectedDate).map((rdv) => (
                  <div 
                    key={rdv.id} 
                    className={`rdv-item status-${rdv.statut}`}
                    onClick={() => handleViewRendezvous(rdv)}
                  >
                    <div className="rdv-time">
                      <FontAwesomeIcon icon={faClock} className="me-2" />
                      {rdv.heure}
                    </div>
                    <div className="rdv-patient">
                      <FontAwesomeIcon icon={faUser} className="me-2" />
                      {patients.find(p => p.id === rdv.patientId)?.prenom} {patients.find(p => p.id === rdv.patientId)?.nom || rdv.patientNom}
                    </div>
                    <div className="rdv-status">
                      <span className={`badge status-badge-${rdv.statut}`}>
                        {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                      </span>
                    </div>
                    <div className="rdv-actions">
                      <button 
                        className="btn btn-sm btn-outline-primary me-1" 
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditRendezvous(rdv);
                          setShowMedecinRdvs(false);
                        }}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button 
                        className="btn btn-sm btn-outline-danger" 
                        onClick={(e) => {
                          e.stopPropagation();
                          if (window.confirm('Êtes-vous sûr de vouloir supprimer ce rendez-vous ?')) {
                            handleDeleteRendezvous(rdv.id);
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">Aucun rendez-vous pour ce médecin à cette date</p>
              </div>
            )}
            
            <div className="text-center mt-3">
              <button 
                className="btn btn-primary" 
                onClick={() => {
                  resetRdvForm();
                  setRdvForm(prev => ({
                    ...prev,
                    medecinId: selectedMedecinId,
                    date: selectedDate.date.toISOString().split('T')[0]
                  }));
                  setShowAddForm(true);
                  setShowMedecinRdvs(false);
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Ajouter un rendez-vous
              </button>
            </div>
          </div>
        )}

        {/* Détails d'un rendez-vous */}
        {showDetailsView && showDetailsView.type === 'rendezvous' && (
          <div className="rdv-details">
            <div className="card mb-3">
              <div className="card-body">
                <h5 className="card-title">Rendez-vous</h5>
                <p className="text-muted">
                  {formatDate(showDetailsView.data.date)} à {showDetailsView.data.heure}
                </p>
                
                <div className="info-item">
                  <strong>Patient:</strong> {showDetailsView.data.patientNom}
                </div>
                
                <div className="info-item">
                  <strong>Médecin:</strong> Dr. {showDetailsView.data.medecinNom}
                </div>
                
                <div className="info-item">
                  <strong>Spécialité:</strong> {showDetailsView.data.medecinSpecialite}
                </div>
                
                {showDetailsView.data.motif && (
                  <div className="info-item">
                    <strong>Motif:</strong> {showDetailsView.data.motif}
                  </div>
                )}
                
                <div className="info-item">
                  <strong>Statut:</strong> 
                  <span className={`badge ms-2 status-badge-${showDetailsView.data.statut}`}>
                    {showDetailsView.data.statut.charAt(0).toUpperCase() + showDetailsView.data.statut.slice(1)}
                  </span>
                </div>
                
                <div className="d-flex justify-content-between mt-4">
                  <button 
                    className="btn btn-outline-primary" 
                    onClick={() => handleEditRendezvous(showDetailsView.data)}
                  >
                    <FontAwesomeIcon icon={faEdit} className="me-2" />
                    Modifier
                  </button>
                  <button 
                    className="btn btn-outline-danger" 
                    onClick={() => {
                      handleDeleteRendezvous(showDetailsView.data.id);
                      setShowDetailsView(null);
                    }}
                  >
                    <FontAwesomeIcon icon={faTrash} className="me-2" />
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Formulaire d'ajout/modification de rendez-vous */}
        {activeTab === 'rendezvous' && showAddForm && (
          <div className="rdv-form">
            <h5 className="form-title">{currentRendezvous ? 'Modifier le rendez-vous' : 'Ajouter un rendez-vous'}</h5>
            <form onSubmit={handleAddRendezvous}>
              <div className="mb-3">
                <label className="form-label">Médecin</label>
                <select
                  name="medecinId"
                  className="form-select"
                  value={rdvForm.medecinId}
                  onChange={handleRdvChange}
                  required
                >
                  <option value="">Sélectionner un médecin</option>
                  {medecins.map((medecin) => (
                    <option key={medecin.id} value={medecin.id}>
                      Dr. {medecin.prenom} {medecin.nom} - {medecin.specialite}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="mb-3">
                <label className="form-label">Patient</label>
                <select
                  name="patientId"
                  className="form-select"
                  value={rdvForm.patientId}
                  onChange={handleRdvChange}
                  required
                >
                  <option value="">Sélectionner un patient</option>
                  {patients.map((patient) => (
                    <option key={patient.id} value={patient.id}>
                      {patient.prenom} {patient.nom}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="mb-3">
                <label className="form-label">Date</label>
                <input
                  type="date"
                  name="date"
                  className="form-control"
                  value={rdvForm.date}
                  onChange={handleRdvChange}
                  required
                />
              </div>
              
              <div className="mb-3">
                <label className="form-label">Heure</label>
                <div className="time-slots-container">
                  {rdvForm.medecinId && rdvForm.date ? (
                    getCreneauxAvecStatut().map((creneau) => (
                      <div 
                        key={creneau.heure}
                        className={`time-slot ${creneau.statut} ${rdvForm.heure === creneau.heure ? 'selected' : ''}`}
                        onClick={() => {
                          if (creneau.statut !== 'complet') {
                            setRdvForm({...rdvForm, heure: creneau.heure});
                          }
                        }}
                      >
                        {creneau.heure}
                        {creneau.statut === 'partiel' && (
                          <div className="slot-info">
                            {creneau.nombreRdv}/{3} occupé{creneau.nombreRdv > 1 ? 's' : ''}
                          </div>
                        )}
                        {creneau.statut === 'complet' && (
                          <div className="slot-info">Complet</div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="alert alert-info">
                      Veuillez sélectionner un médecin et une date
                    </div>
                  )}
                </div>
              </div>
              
              <div className="mb-3">
                <label className="form-label">Motif</label>
                <textarea
                  name="motif"
                  className="form-control"
                  value={rdvForm.motif}
                  onChange={handleRdvChange}
                  rows="3"
                />
              </div>
              
              <div className="mb-3">
                <label className="form-label">Statut</label>
                <select
                  name="statut"
                  className="form-select"
                  value={rdvForm.statut}
                  onChange={handleRdvChange}
                  required
                >
                  {statutsRdv.map((statut) => (
                    <option key={statut} value={statut}>
                      {statut.charAt(0).toUpperCase() + statut.slice(1)}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="form-actions">
                <button type="submit" className="btn btn-primary w-100">
                  <FontAwesomeIcon icon={faCheck} className="me-2" />
                  {currentRendezvous ? 'Mettre à jour' : 'Ajouter'}
                </button>
              </div>
            </form>
          </div>
        )}
        

        {/* Onglet Mot de passe */}
        {activeTab === 'password' && (
          <div className="password-section">
            <div className="card mb-3">
              <div className="card-body">
                <form onSubmit={(e) => { e.preventDefault(); handlePasswordChange(); }}>
                  <div className="mb-3">
                    <label className="form-label">Nouveau mot de passe</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">
                    <FontAwesomeIcon icon={faCheck} className="me-2" />
                    Mettre à jour le mot de passe
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Onglet Demandes rapides */}
        {activeTab === 'demandesRapides' && (
          <div className="demandes-rapides-section">
            <RenderDemandesRapides />
          </div>
        )}

        {/* Onglet Affiliations */}
{activeTab === 'affiliations' && (
  <div className="affiliations-section">
      
                <AffiliationRequestsManager onRequestProcessed={fetchPendingRequests} />
            
  </div>
)}



      </main>

      <ToastContainer position="bottom-center" autoClose={3000} />
    </div>
  );
};


  if (!structureData) return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Chargement...</span>
      </div>
    </div>
  );

if(isMobile){
  return <StructureDashboardMobile />

                    

};


 return (
    <div className="dashboard-container">
      {/* Menu latéral */}
      <div className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <h3>{!sidebarCollapsed && structureData.nom}</h3>
          <button className="toggle-btn" onClick={toggleSidebar}>
            <FontAwesomeIcon icon={sidebarCollapsed ? faChevronRight : faChevronLeft} />
          </button>
        </div>
        
        <div className="sidebar-menu">
          <ul>
            <li className={activeTab === 'info' ? 'active' : ''} onClick={() => setActiveTab('info')}>
              <FontAwesomeIcon icon={faHome} />
              {!sidebarCollapsed && <span>Informations</span>}
            </li>
            <li className={activeTab === 'affiliations' ? 'active' : ''} onClick={() => setActiveTab('affiliations')}>
              <FontAwesomeIcon icon={faLink} />
              {!sidebarCollapsed && <span>Affiliations</span>}
              {(pendingDoctorRequests?.length || 0) + (affiliationRequests?.filter(req => req.statut === 'en attente')?.length || 0) > 0 && (
                <span className="badge bg-danger">
                  {(pendingDoctorRequests?.length || 0) + (affiliationRequests?.filter(req => req.statut === 'en attente')?.length || 0)}
                </span>
              )}
            </li>
            <li className={activeTab === 'medecins' ? 'active' : ''} onClick={() => setActiveTab('medecins')}>
              <FontAwesomeIcon icon={faUserMd} />
              {!sidebarCollapsed && <span>Médecins</span>}
              <span className="badge bg-info">{medecins.length}</span>
            </li>
            <li className={activeTab === 'patients' ? 'active' : ''} onClick={() => setActiveTab('patients')}>
              <FontAwesomeIcon icon={faUser} />
              {!sidebarCollapsed && <span>Patients</span>}
              <span className="badge bg-info">{patients.length}</span>
            </li>
            <li className={activeTab === 'rendezvous' ? 'active' : ''} onClick={() => setActiveTab('rendezvous')}>
  <FontAwesomeIcon icon={faCalendarAlt} />
  {!sidebarCollapsed && <span>Rendez-vous</span>}
  <div className="badge-container">
    <span className="badge bg-info">{rendezvous.length}</span>
    {quickRequestsCount > 0 && (
      <span className="badge bg-danger quick-badge">{quickRequestsCount}</span>
    )}
  </div>
</li>

<li className={activeTab === 'archives' ? 'active' : ''} onClick={() => setActiveTab('archives')}>
      <FontAwesomeIcon icon={faArchive} />
      {!sidebarCollapsed && <span>Archives</span>}
      <span className="badge bg-info">{archives.length}</span>
    </li>
    
            <li className={activeTab === 'demandesRapides' ? 'active' : ''} onClick={() => setActiveTab('demandesRapides')}>
              <FontAwesomeIcon icon={faBolt} />
              {!sidebarCollapsed && <span>Rendez-vous rapides</span>}
              <div className="badge-container">
                <span className="badge bg-warning ms-2">{demandesRapides.length}</span>
              </div>
            </li>
            <li onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} />
              {!sidebarCollapsed && <span>Déconnexion</span>}
            </li>
          </ul>
        </div>
      </div>

      {/* Contenu principal */}
      <div className={`main-content ${sidebarCollapsed ? 'expanded' : ''}`}>
        {/* En-tête avec le titre de la section active */}
        <div className="content-header">
          <h2>
            {activeTab === 'info' && 'Informations de la structure'}
            {activeTab === 'affiliations' && 'Gestion des affiliations'}
            {activeTab === 'medecins' && 'Gestion des médecins'}
            {activeTab === 'patients' && 'Gestion des patients'}
            {activeTab === 'rendezvous' && 'Gestion des rendez-vous'}
            {activeTab === 'archives' && 'Archives des patients'}
            {activeTab === 'password' && 'Modification du mot de passe'}
            {activeTab === 'demandesRapides'}
          </h2>
          
          {/* Boutons d'action spécifiques à chaque onglet */}
          <div className="action-buttons">
            {activeTab === 'medecins' && (
              <button 
                className="btn btn-primary" 
                onClick={() => {
                  resetMedecinForm();
                  setShowMedecinForm(!showMedecinForm);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                {showMedecinForm ? 'Annuler' : 'Ajouter un médecin'}
              </button>
            )}
            
            {activeTab === 'patients' && (
              <button 
                className="btn btn-primary" 
                onClick={() => {
                  resetPatientForm();
                  setShowPatientForm(!showPatientForm);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                {showPatientForm ? 'Annuler' : 'Ajouter un patient'}
              </button>
            )}
            
            {activeTab === 'rendezvous' && (
              <button 
                className="btn btn-primary" 
                onClick={() => {
                  resetRdvForm();
                  setShowRendezvousForm(!showRendezvousForm);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                {showRendezvousForm ? 'Annuler' : 'Ajouter un rendez-vous'}
              </button>
            )}
            
            {activeTab === 'archives' && (
              <button 
                className="btn btn-primary" 
                onClick={() => {
                  resetArchiveForm();
                  setShowArchiveForm(!showArchiveForm);
                }}
              >
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                {showArchiveForm ? 'Annuler' : 'Ajouter une archive'}
              </button>
            )}
          </div>
        </div>

        {/* Affichage des messages de notification */}
        {message && (
          <div className={`alert alert-dismissible fade show ${message.includes('Erreur') ? 'alert-danger' : 'alert-success'}`} role="alert">
            {message}
            <button type="button" className="btn-close" onClick={() => setMessage('')}></button>
          </div>
        )}

        {/* Contenu des différents onglets */}
        <div className="content-body">
          {/* Onglet Informations */}
          {activeTab === 'info' && (
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="row">
                  {Object.keys(form).map((key) => (
                    key !== 'createdAt' && key !== 'updatedAt' ? (
                      <div className="col-md-6 mb-3" key={key}>
                        <label className="form-label">{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                        <input
                          name={key}
                          value={form[key] || ''}
                          onChange={handleChange}
                          className="form-control"
                          placeholder={key}
                        />
                      </div>
                    ) : null
                  ))}
                </div>
                <div className="text-end mt-3">
                  <button onClick={handleUpdate} className="btn btn-primary">
                    <FontAwesomeIcon icon={faCheck} className="me-2" />
                    Mettre à jour
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Onglet Affiliations */}
          {activeTab === 'affiliations' && (
            <div className="card shadow-sm">
              <div className="card-body">
                <AffiliationRequestsManager onRequestProcessed={fetchPendingRequests} />
              </div>
            </div>
          )}

          {/* Onglet Médecins - Affichage en mode carte */}
          {activeTab === 'medecins' && (
            <div>
              {showMedecinForm && (
                <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <h5>{currentMedecin ? 'Modifier le médecin' : 'Ajouter un médecin'}</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleAddMedecin}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Nom</label>
                        <input
                          type="text"
                          name="nom"
                          className="form-control"
                          value={medecinForm.nom}
                          onChange={handleMedecinChange}
                          
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Prénom</label>
                        <input
                          type="text"
                          name="prenom"
                          className="form-control"
                          value={medecinForm.prenom}
                          onChange={handleMedecinChange}
                          
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Spécialité</label>
                        <select
                          name="specialite"
                          className="form-select"
                          value={medecinForm.specialite}
                          onChange={handleMedecinChange}
                          required
                        >
                          <option value="">Sélectionner une spécialité</option>
                          {specialites.map((spec) => (
                            <option key={spec} value={spec}>{spec}</option>
                          ))}
                        </select>
                        {medecinForm.specialite === 'Autre' && (
                          <input
                            type="text"
                            name="specialiteAutre"
                            className="form-control mt-2"
                            placeholder="Précisez la spécialité"
                            value={medecinForm.specialiteAutre || ''}
                            onChange={handleMedecinChange}
                          />
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Téléphone</label>
                        <input
                          type="tel"
                          name="telephone"
                          className="form-control"
                          value={medecinForm.telephone}
                          onChange={handleMedecinChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          value={medecinForm.email}
                          onChange={handleMedecinChange}
                          
                        />
                      </div>
                    
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Disponibilités</label>
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>Jour</th>
                              <th>Disponible</th>
                              <th>Heure de début</th>
                              <th>Heure de fin</th>
                            </tr>
                          </thead>
                          <tbody>
                            {joursSemaine.map((jour) => (
                              <tr key={jour}>
                                <td>{jour.charAt(0).toUpperCase() + jour.slice(1)}</td>
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`disponible-${jour}`}
                                      checked={medecinForm.disponibilites[jour].actif}
                                      onChange={() => handleDisponibiliteChange(jour, 'actif')}
                                    />
                                    <label className="form-check-label" htmlFor={`disponible-${jour}`}>
                                      {medecinForm.disponibilites[jour].actif ? 'Oui' : 'Non'}
                                    </label>
                                  </div>
                                </td>
                                <td>
                                  <input
                                    type="time"
                                    className="form-control"
                                    value={medecinForm.disponibilites[jour].debut}
                                    onChange={(e) => handleDisponibiliteChange(jour, 'debut', e.target.value)}
                                    disabled={!medecinForm.disponibilites[jour].actif}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="time"
                                    className="form-control"
                                    value={medecinForm.disponibilites[jour].fin}
                                    onChange={(e) => handleDisponibiliteChange(jour, 'fin', e.target.value)}
                                    disabled={!medecinForm.disponibilites[jour].actif}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Assurances acceptées</label>
                      <div className="d-flex flex-wrap">
                        {assurancesList.map((assurance) => (
                          <div className="form-check me-3 mb-2" key={assurance}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`assurance-medecin-${assurance}`}
                              name="assurances"
                              value={assurance}
                              checked={medecinForm.assurances.includes(assurance)}
                              onChange={handleMedecinChange}
                            />
                            <label className="form-check-label" htmlFor={`assurance-medecin-${assurance}`}>
                              {assurance}
                            </label>
                          </div>
                        ))}
                      </div>
                      {medecinForm.assurances.includes('Autre') && (
                        <input
                          type="text"
                          name="assuranceAutre"
                          className="form-control mt-2"
                          placeholder="Précisez l'assurance"
                          value={medecinForm.assuranceAutre || ''}
                          onChange={handleMedecinChange}
                        />
                      )}
                    </div>

                    <div className="text-end mt-3">
                      <button type="button" className="btn btn-secondary me-2" onClick={() => {
                        resetMedecinForm();
                        setShowMedecinForm(false);
                      }}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" />
                        Annuler
                      </button>
                      <button type="submit" className="btn btn-primary">
                        <FontAwesomeIcon icon={faCheck} className="me-2" />
                        {currentMedecin ? 'Mettre à jour' : 'Ajouter'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* Liste des médecins en mode carte */}
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
              {medecins.length > 0 ? (
                medecins.map((medecin) => (
                  <div className="col" key={medecin.id}>
                    <div className="card h-100 shadow-sm hover-card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start">
                          <h5 className="card-title">Dr. {medecin.prenom} {medecin.nom}</h5>
                          <span className="badge bg-info">{medecin.specialite}</span>
                        </div>
                        <p className="card-text">
                          <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                          {medecin.telephone}
                        </p>
                        <p className="card-text">
                          <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                          {medecin.email}
                        </p>
                        <div className="mt-3">
                          <h6>Disponibilités:</h6>
                          <div className="disponibilites-container">
                            {Array.isArray(medecin.disponibilites) ? (
                              medecin.disponibilites.map((dispo, index) => (
                                <span key={index} className="badge bg-light text-dark me-1 mb-1">
                                  {dispo.jour}: {dispo.heureDebut}-{dispo.heureFin}
                                </span>
                              ))
                            ) : (
                              Object.entries(medecin.disponibilites || {}).map(([jour, dispo]) => (
                                dispo.actif && (
                                  <span key={jour} className="badge bg-light text-dark me-1 mb-1">
                                    {jour.charAt(0).toUpperCase() + jour.slice(1)}: {dispo.debut}-{dispo.fin}
                                  </span>
                                )
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer bg-transparent border-top-0">
                        <div className="d-flex justify-content-end">
                          <button
                            className="btn btn-sm btn-outline-primary me-2"
                            onClick={() => handleEditMedecin(medecin)}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDeleteMedecin(medecin.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center py-5">
                  <p className="text-muted">Aucun médecin n'a été ajouté</p>
                  <button 
                    className="btn btn-primary" 
                    onClick={() => {
                      resetMedecinForm();
                      setShowMedecinForm(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                    Ajouter un médecin
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Onglet Patients - Affichage en mode carte */}
        {activeTab === 'patients' && (
          <div>
            {showPatientForm && (
              <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <h5>{currentPatient ? 'Modifier le patient' : 'Ajouter un patient'}</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleAddPatient}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Nom</label>
                        <input
                          type="text"
                          name="nom"
                          className="form-control"
                          value={patientForm.nom}
                          onChange={handlePatientChange}
                          
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Prénom</label>
                        <input
                          type="text"
                          name="prenom"
                          className="form-control"
                          value={patientForm.prenom}
                          onChange={handlePatientChange}
                          
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Date de naissance</label>
                        <input
                          type="date"
                          name="dateNaissance"
                          className="form-control"
                          value={patientForm.dateNaissance}
                          onChange={handlePatientChange}
                          
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Téléphone</label>
                        <input
                          type="tel"
                          name="telephone"
                          className="form-control"
                          value={patientForm.telephone}
                          onChange={handlePatientChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          value={patientForm.email}
                          onChange={handlePatientChange}
                          
                        />
                      </div>
                    
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Assurances</label>
                      <div className="d-flex flex-wrap">
                        {assurancesList.map((assurance) => (
                          <div className="form-check me-3 mb-2" key={assurance}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`assurance-patient-${assurance}`}
                              name="assurances"
                              value={assurance}
                              checked={patientForm.assurances.includes(assurance)}
                              onChange={handlePatientChange}
                            />
                            <label className="form-check-label" htmlFor={`assurance-patient-${assurance}`}>
                              {assurance}
                            </label>
                          </div>
                        ))}
                      </div>
                      {patientForm.assurances.includes('Autre') && (
                        <input
                          type="text"
                          name="assuranceAutre"
                          className="form-control mt-2"
                          placeholder="Précisez l'assurance"
                          value={patientForm.assuranceAutre || ''}
                          onChange={handlePatientChange}
                        />
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Diagnostics</label>
                      <textarea
                        name="diagnostics"
                        className="form-control"
                        value={patientForm.diagnostics}
                        onChange={handlePatientChange}
                        rows="3"
                        placeholder="Entrez les diagnostics du patient"
                      />
                    </div>

                    <div className="text-end mt-3">
                      <button type="button" className="btn btn-secondary me-2" onClick={() => {
                        resetPatientForm();
                        setShowPatientForm(false);
                      }}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" />
                        Annuler
                      </button>
                      <button type="submit" className="btn btn-primary">
                        <FontAwesomeIcon icon={faCheck} className="me-2" />
                        {currentPatient ? 'Mettre à jour' : 'Ajouter'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* Liste des patients en mode carte */}
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
              {patients.length > 0 ? (
                patients.map((patient) => (
                  <div className="col" key={patient.id}>
                    <div className="card h-100 shadow-sm hover-card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start">
                          <h5 className="card-title">{patient.prenom} {patient.nom}</h5>
                          <span className="badge bg-secondary">
                            {new Date().getFullYear() - new Date(patient.dateNaissance).getFullYear()} ans
                          </span>
                        </div>
                        <p className="card-text">
                          <small className="text-muted">Né(e) le {new Date(patient.dateNaissance).toLocaleDateString()}</small>
                        </p>
                        <p className="card-text">
                          <FontAwesomeIcon icon={faPhone} className="me-2 text-secondary" />
                          {patient.telephone}
                        </p>
                        <p className="card-text">
                          <FontAwesomeIcon icon={faEnvelope} className="me-2 text-secondary" />
                          {patient.email}
                        </p>
                        <div className="mt-3">
                          <h6>Assurances:</h6>
                          <div>
                            {patient.assurances && patient.assurances.map((assurance, index) => (
                              <span key={index} className="badge bg-light text-dark me-1 mb-1">
                                {assurance}
                              </span>
                            ))}
                          </div>
                        </div>
                        {patient.diagnostics && (
                          <div className="mt-3">
                            <h6>Diagnostics:</h6>
                            <p className="text-muted">{patient.diagnostics}</p>
                          </div>
                        )}
                      </div>
                      <div className="card-footer bg-transparent border-top-0">
                        <div className="d-flex justify-content-end">
                          <button
                            className="btn btn-sm btn-outline-primary me-2"
                            onClick={() => handleEditPatient(patient)}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDeletePatient(patient.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center py-5">
                  <p className="text-muted">Aucun patient n'a été ajouté</p>
                  <button 
                    className="btn btn-primary" 
                    onClick={() => {
                      resetPatientForm();
                      setShowPatientForm(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                    Ajouter un patient
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Onglet Rendez-vous - Vue mensuelle */}
        {activeTab === 'rendezvous' && (
          <div>
            {showRendezvousForm && (
              <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <h5>{currentRendezvous ? 'Modifier le rendez-vous' : 'Ajouter un rendez-vous'}</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleAddRendezvous}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Médecin</label>
                        <select
                          name="medecinId"
                          className="form-select"
                          value={rdvForm.medecinId}
                          onChange={handleRdvChange}
                          required
                        >
                          <option value="">Sélectionner un médecin</option>
                          {medecins.map((medecin) => (
                            <option key={medecin.id} value={medecin.id}>
                              Dr. {medecin.prenom} {medecin.nom} - {medecin.specialite}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Patient</label>
                        <select
                          name="patientId"
                          className="form-select"
                          value={rdvForm.patientId}
                          onChange={handleRdvChange}
                          required
                        >
                          <option value="">Sélectionner un patient</option>
                          {patients.map((patient) => (
                            <option key={patient.id} value={patient.id}>
                              {patient.prenom} {patient.nom}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label className="form-label">Date</label>
                        <input
                          type="date"
                          name="date"
                          className="form-control"
                          value={rdvForm.date}
                          onChange={handleRdvChange}
                          required
                        />
                      </div>
                      <div className="mb-3">
  <label className="form-label">Heure</label>
  <div className="time-slots-container">
    {rdvForm.medecinId && rdvForm.date ? (
      getCreneauxAvecStatut().map((creneau) => (
        <div 
          key={creneau.heure}
          className={`time-slot ${creneau.statut} ${rdvForm.heure === creneau.heure ? 'selected' : ''}`}
          onClick={() => {
            if (creneau.statut !== 'complet') {
              setRdvForm({...rdvForm, heure: creneau.heure});
            }
          }}
        >
          {creneau.heure}
          {creneau.statut === 'partiel' && (
            <div className="slot-info">
              {creneau.nombreRdv}/{3} occupé{creneau.nombreRdv > 1 ? 's' : ''}
            </div>
          )}
          {creneau.statut === 'complet' && (
            <div className="slot-info">Complet</div>
          )}
        </div>
      ))
    ) : (
      <div className="alert alert-info">
        Veuillez sélectionner un médecin et une date
      </div>
    )}
  </div>
</div>


                  {/*  <div className="col-md-4 mb-3">
                        <label className="form-label">Durée (minutes)</label>
                        <select
                          name="duree"
                          className="form-select"
                          value={rdvForm.duree}
                          onChange={handleRdvChange}
                          required
                        >
                          {dureesRdv.map((duree) => (
                            <option key={duree} value={duree}>
                              {duree} min
                            </option>
                          ))}
                        </select>
                      </div> */}
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Motif</label>
                        <textarea
                          name="motif"
                          className="form-control"
                          value={rdvForm.motif}
                          onChange={handleRdvChange}
                          rows="3"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Statut</label>
                        <select
                          name="statut"
                          className="form-select"
                          value={rdvForm.statut}
                          onChange={handleRdvChange}
                          required
                        >
                          {statutsRdv.map((statut) => (
                            <option key={statut} value={statut}>
                              {statut.charAt(0).toUpperCase() + statut.slice(1)}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="text-end mt-3">
                      <button type="button" className="btn btn-secondary me-2" onClick={() => {
                        resetRdvForm();
                        setShowRendezvousForm(false);
                      }}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" />
                        Annuler
                      </button>
                      <button type="submit" className="btn btn-primary">
                        <FontAwesomeIcon icon={faCheck} className="me-2" />
                        {currentRendezvous ? 'Mettre à jour' : 'Ajouter'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}



            {/* Vue calendrier des rendez-vous */}
            <div className="card shadow-sm mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
               
                <div className="d-flex align-items-center">
                  <button className="btn btn-sm btn-outline-secondary me-2" onClick={handlePrevMonth}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </button>
                  <h5 className="mb-0 mx-3">
                    {currentMonth.toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}
                  </h5>
                  <button className="btn btn-sm btn-outline-secondary ms-2" onClick={handleNextMonth}>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                </div>
                <div>
                  <h5>
                    Calendrier des rendez-vous
                    <FontAwesomeIcon icon={faCalendarAlt} className="me-2 ms-2" />

                  </h5>
                </div>
              </div>
              <div className="card-body p-0">
                <div className="calendar-container">
                  <div className="calendar-header">
                    {['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'].map((day, index) => (
                      <div key={index} className="calendar-cell header">
                        {day}
                      </div>
                    ))}
                  </div>
                  <div className="calendar-body">
                    {getMonthData().map((day, index) => (
                      <div 
                        key={index} 
                        className={`calendar-cell ${!day.isCurrentMonth ? 'other-month' : ''} ${day.hasEvents ? 'has-events' : ''}`}
                        onClick={() => handleDateClick(day)}
                      >
                        <div className="date-number">{day.date.getDate()}</div>
                        {day.hasEvents && (
                          <div className="event-indicator">
                            <span className="badge rounded-pill bg-primary">
                              {day.medecinCount} {day.medecinCount > 1 ? 'médecins' : 'médecin'}
                            </span>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
 {activeTab === 'demandesRapides' && (
          <div>

             <RenderDemandesRapides />
          </div>
        ) }

        {/* Onglet Archives */}
        {activeTab === 'archives' && (
          <div>
            {showArchiveForm && (
              <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <h5>{currentArchive ? "Modifier l'archive" : "Ajouter une archive"}</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleAddArchive}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="patientId" className="form-label">Patient</label>
                        <select 
                          id="patientId" 
                          name="patientId" 
                          className="form-select" 
                          value={archiveForm.patientId} 
                          onChange={handleArchiveChange}
                          required
                        >
                          <option value="">Sélectionner un patient</option>
                          {patients.map(patient => (
                            <option key={patient.id} value={patient.id}>
                              {patient.prenom} {patient.nom}
                            </option>
                          ))}
                        </select>
                      </div>
                      
                      <div className="col-md-6 mb-3">
                        <label htmlFor="titre" className="form-label">Titre</label>
                        <input 
                          type="text" 
                          id="titre" 
                          name="titre" 
                          className="form-control" 
                          value={archiveForm.titre} 
                          onChange={handleArchiveChange}
                          required
                        />
                      </div>
                    </div>
                    
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="description" className="form-label">Description</label>
                        <textarea 
                          id="description" 
                          name="description" 
                          className="form-control" 
                          value={archiveForm.description} 
                          onChange={handleArchiveChange}
                          rows="3"
                        />
                      </div>
                      
                      <div className="col-md-6 mb-3">
                        <label htmlFor="notes" className="form-label">Notes</label>
                        <textarea 
                          id="notes" 
                          name="notes" 
                          className="form-control" 
                          value={archiveForm.notes} 
                          onChange={handleArchiveChange}
                          rows="3"
                          />
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date" className="form-label">Date</label>
                          <input 
                            type="date" 
                            id="date" 
                            name="date" 
                            className="form-control" 
                            value={archiveForm.date} 
                            onChange={handleArchiveChange}
                            required
                          />
                        </div>
                        
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Tags</label>
                          <div className="d-flex flex-wrap">
                            {tagsList.map(tag => (
                              <div className="form-check me-3 mb-2" key={tag}>
                                <input 
                                  type="checkbox" 
                                  className="form-check-input" 
                                  id={`tag-${tag}`} 
                                  name="tags" 
                                  value={tag}
                                  checked={archiveForm.tags.includes(tag)}
                                  onChange={handleArchiveChange}
                                />
                                <label className="form-check-label" htmlFor={`tag-${tag}`}>
                                  {tag}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      
                      <div className="mb-3">
                        <label htmlFor="files" className="form-label">Fichiers</label>
                        <input 
                          type="file" 
                          id="files" 
                          className="form-control" 
                          onChange={handleFileChange}
                          multiple
                        />
                        <div className="form-text">
                          Vous pouvez sélectionner plusieurs fichiers.
                        </div>
                      </div>
                      
                      {selectedFiles.length > 0 && (
                        <div className="mb-3">
                          <h6>Fichiers sélectionnés :</h6>
                          <ul className="list-group">
                            {selectedFiles.map((file, index) => (
                              <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                {file.name}
                                <span className="badge bg-primary rounded-pill">{(file.size / 1024).toFixed(2)} KB</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      
                      {currentArchive && archiveForm.files && archiveForm.files.length > 0 && (
                        <div className="mb-3">
                          <h6>Fichiers existants :</h6>
                          <ul className="list-group">
                            {archiveForm.files.map((file, index) => (
                              <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                <a href={file.url} target="_blank" rel="noopener noreferrer">{file.name}</a>
                                <button 
                                  type="button" 
                                  className="btn btn-sm btn-danger"
                                  onClick={() => handleDeleteFile(currentArchive.id, file.path, index)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      
                      <div className="text-end mt-3">
                        <button type="button" className="btn btn-secondary me-2" onClick={() => {
                          resetArchiveForm();
                          setShowArchiveForm(false);
                        }}>
                          <FontAwesomeIcon icon={faTimes} className="me-2" />
                          Annuler
                        </button>
                        <button type="submit" className="btn btn-primary">
                          <FontAwesomeIcon icon={faCheck} className="me-2" />
                          {currentArchive ? "Mettre à jour" : "Ajouter"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
              
              <div className="card shadow-sm">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5>Archives des patients</h5>
                  <div className="d-flex">
                    <input 
                      type="text" 
                      className="form-control form-control-sm me-2" 
                      placeholder="Rechercher un patient" 
                      value={filtreArchivePatient}
                      onChange={(e) => setFiltreArchivePatient(e.target.value)}
                    />
                    <button className="btn btn-sm btn-outline-secondary">
                      <FontAwesomeIcon icon={faSearch} />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  {archives.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Patient</th>
                            <th>Titre</th>
                            <th>Date</th>
                            <th>Tags</th>
                            <th>Fichiers</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {archives
                            .filter(archive => {
                              if (!filtreArchivePatient) return true;
                              const patientNom = archive.patientNom || '';
                              return patientNom.toLowerCase().includes(filtreArchivePatient.toLowerCase());
                            })
                            .map(archive => (
                            <tr key={archive.id}>
                              <td>{archive.patientNom}</td>
                              <td>{archive.titre}</td>
                              <td>{new Date(archive.date).toLocaleDateString()}</td>
                              <td>
                                {archive.tags && archive.tags.map((tag, index) => (
                                  <span key={index} className="badge bg-info me-1">{tag}</span>
                                ))}
                              </td>
                              <td>
                                {archive.files && (
                                  <span className="badge bg-secondary">{archive.files.length}</span>
                                )}
                              </td>
                              <td>
                                <button 
                                  className="btn btn-sm btn-outline-primary me-1"
                                  onClick={() => handleEditArchive(archive)}
                                >
                                  <FontAwesomeIcon icon={faEdit} />
                                </button>
                                <button 
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => handleDeleteArchive(archive.id)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <p className="text-muted">Aucune archive n'a été ajoutée</p>
                      <button 
                        className="btn btn-primary" 
                        onClick={() => {
                          resetArchiveForm();
                          setShowArchiveForm(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                        Ajouter une archive
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Onglet Mot de passe */}
          {activeTab === 'password' && (
            <div className="card shadow-sm">
              <div className="card-body">
                <form onSubmit={(e) => { e.preventDefault(); handlePasswordChange(); }}>
                  <div className="mb-3">
                    <label className="form-label">Nouveau mot de passe</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                      <FontAwesomeIcon icon={faCheck} className="me-2" />
                      Mettre à jour le mot de passe
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modales pour la gestion des rendez-vous */}
      {/* Modal pour afficher les médecins d'une date */}
      <Modal show={showDateModal} onHide={() => setShowDateModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Rendez-vous du {selectedDate && selectedDate.date.toLocaleDateString()}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="list-group">
            {selectedDate && getMedecinsByDate(selectedDate).map((item, index) => (
              <button 
                key={index} 
                className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                onClick={() => handleMedecinClick(item.medecin.id)}
              >
                <div>
                  <h5>Dr. {item.medecin.prenom} {item.medecin.nom}</h5>
                  <p className="mb-1 text-muted">{item.medecin.specialite}</p>
                </div>
                <span className="badge bg-primary rounded-pill">{item.rdvCount} RDV</span>
              </button>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDateModal(false)}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal pour afficher les rendez-vous d'un médecin à une date donnée */}
      <Modal show={showMedecinRdvModal} onHide={() => setShowMedecinRdvModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedMedecinId && selectedDate && (
              <>
                Rendez-vous de Dr. {medecins.find(m => m.id === selectedMedecinId)?.prenom} {medecins.find(m => m.id === selectedMedecinId)?.nom}
                <p className="mb-0 fs-6 text-muted">
                  {selectedDate.date.toLocaleDateString()}
                </p>
              </>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="rdv-list">
            {selectedMedecinId && selectedDate && getMedecinRdvs(selectedMedecinId, selectedDate).map((rdv, index) => (
              <div 
                key={rdv.id} 
                className={`rdv-item ${draggedRdv?.id === rdv.id ? 'dragging' : ''} status-${rdv.statut}`}
                draggable
                onDragStart={() => handleDragStart(rdv)}
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => handleDrop(rdv)}
                onClick={() => handleRdvClick(rdv)}
              >
                <div className="rdv-time">
                  <FontAwesomeIcon icon={faClock} className="me-2" />
                  {rdv.heure}{/* ({rdv.duree} min) */}
                </div>
                <div className="rdv-patient">
                  <FontAwesomeIcon icon={faUser} className="me-2" />
                  {patients.find(p => p.id === rdv.patientId)?.prenom} {patients.find(p => p.id === rdv.patientId)?.nom || rdv.patientNom}
                </div>
                <div className="rdv-status">
                  <span className={`badge status-badge-${rdv.statut}`}>
                    {rdv.statut.charAt(0).toUpperCase() + rdv.statut.slice(1)}
                  </span>
                </div>
                <div className="rdv-actions">
                  <button className="btn btn-sm btn-outline-secondary me-1" title="Voir détails">
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                  <button 
                    className="btn btn-sm btn-outline-primary me-1" 
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditRendezvous(rdv);
                      setShowMedecinRdvModal(false);
                    }}
                    title="Modifier"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <button 
                    className="btn btn-sm btn-outline-danger" 
                    onClick={(e) => {
                      e.stopPropagation();
                      if (window.confirm('Êtes-vous sûr de vouloir supprimer ce rendez-vous ?')) {
                        handleDeleteRendezvous(rdv.id);
                        setShowMedecinRdvModal(false);
                      }
                    }}
                    title="Supprimer"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
              </div>
            ))}
            <div className="text-center mt-3">
              <button 
                className="btn btn-primary" 
                onClick={() => {
                  resetRdvForm();
                  setRdvForm(prev => ({
                    ...prev,
                    medecinId: selectedMedecinId,
                    date: selectedDate.date.toISOString().split('T')[0]
                  }));
                  setShowAddForm(true);
                  setShowMedecinRdvs(false);
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Ajouter un rendez-vous
              </button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-between align-items-center">
            <div>
              <small className="text-muted">
                <FontAwesomeIcon icon={faExchangeAlt} className="me-1" />
                Glisser-déposer pour échanger des rendez-vous
              </small>
            </div>
            <Button variant="secondary" onClick={() => setShowMedecinRdvModal(false)}>
              Fermer
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal pour voir toutes les demandes rapides */}
      <Modal 
        show={showQuickRequestsModal} 
        onHide={() => setShowQuickRequestsModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faCalendarPlus} className="me-2" />
            Demandes de rendez-vous rapides
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {quickRequests.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Patient</th>
                    <th>Contact</th>
                    <th>Date souhaitée</th>
                    <th>Heure</th>
                    <th>Motif</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {quickRequests.map(request => (
                    <tr key={request.id}>
                      <td>{request.prenom} {request.nom}</td>
                      <td>
                        <div>{request.telephone}</div>
                        <div><small>{request.email}</small></div>
                      </td>
                      <td>{request.dateFormatted}</td>
                      <td>{request.heureRdv}</td>
                      <td>{request.motif || "-"}</td>
                      <td>
                        <Button 
                          variant="outline-danger" 
                          size="sm" 
                          className="me-1"
                          onClick={() => handleRejectQuickRequest(request.id)}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </Button>
                        <Button 
                          variant="outline-success" 
                          size="sm"
                          onClick={() => {
                            setSelectedQuickRequest(request);
                            setAssignMedecinModal(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faCheck} />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-center py-4">Aucune demande de rendez-vous rapide en attente</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowQuickRequestsModal(false)}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal pour assigner un médecin à une demande */}
      <Modal 
        show={assignMedecinModal} 
        onHide={() => setAssignMedecinModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Assigner un médecin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
  {selectedQuickRequest && (
    <div>
      <div className="mb-3">
        <h6>Détails de la demande:</h6>
        <p><strong>Patient:</strong> {selectedQuickRequest.prenom} {selectedQuickRequest.nom}</p>
        <p><strong>Contact:</strong> {selectedQuickRequest.telephone}</p>
        {selectedQuickRequest.email && <p><strong>Email:</strong> {selectedQuickRequest.email}</p>}
        <p><strong>Date souhaitée:</strong> {selectedQuickRequest.dateFormatted}</p>
        <p><strong>Heure souhaitée:</strong> {selectedQuickRequest.heureRdv}</p>
        {selectedQuickRequest.motif && (
          <p><strong>Motif:</strong> {selectedQuickRequest.motif}</p>
        )}
      </div>
      
      <Form.Group className="mb-3">
        <Form.Label>Sélectionner un médecin</Form.Label>
        <Form.Select 
          value={selectedMedecinForQuick} 
          onChange={(e) => setSelectedMedecinForQuick(e.target.value)}
          required
        >
          <option value="">Choisir un médecin</option>
          {medecins.map(medecin => (
            <option key={medecin.id} value={medecin.id}>
              Dr. {medecin.prenom} {medecin.nom} - {medecin.specialite}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </div>
  )}
</Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setAssignMedecinModal(false)}>
            Annuler
          </Button>
          <Button 
            variant="primary" 
            onClick={handleAcceptQuickRequest}
            disabled={!selectedMedecinForQuick}
          >
            Confirmer le rendez-vous
          </Button>
        </Modal.Footer>
      </Modal>
    
    </div>
  );                 
 
};

export default Rapports;
